// sekcie_v1 (20. 10. 2026, 0.J): DetailRow je jeden, v components/Ui.jsx
// vzhlad_predajne_v2 (20. 10. 2026, ústava 61.10): starý oranžový panel/akcent nahradený hodnotami témy — 2 miest
// ╔══════════════════════════════════════════════════════════════════╗
// ║  _ModuleTemplate.jsx — REFERENČNÁ ŠABLÓNA MODULU MATRIX v2        ║
// ║  Ústava 9.D.1 bod 2 — anti-chyba systém.                          ║
// ╠══════════════════════════════════════════════════════════════════╣
// ║  NOVÝ MODUL VZNIKÁ KÓPIOU TOHTO SÚBORU — NIKDY NIE OD NULY.       ║
// ║  Tým sa ústavné systémové veci NEDAJÚ vynechať.                   ║
// ║                                                                  ║
// ║  POSTUP (ústava 9.D.1):                                          ║
// ║   1. PRE-FLIGHT dokument — schváli Mirko PRED prvým riadkom.      ║
// ║   2. cp _ModuleTemplate.jsx → views/MojModul.jsx                 ║
// ║   3. Vyplň CFG · EDIT_FIELDS · STATUS_FILTERS · polia formulára.  ║
// ║   4. Nahraď TODO značky. Skontroluj DoD checklist (dole).         ║
// ╠══════════════════════════════════════════════════════════════════╣
// ║  ČO JE V ŠABLÓNE ZABUDOVANÉ (ústavné systémové veci):            ║
// ║   • master-detail layout ......................... sek. 56       ║
// ║   • LOCK multi-user (cez useRecordEditor) ........ sek. 53.7      ║
// ║   • DIRTY dialóg pri odchode ..................... sek. 53.1      ║
// ║   • Form → Confirm + DIFF pred uložením .......... 12.0/3 · 53.8  ║
// ║   • audit kto/čo/kedy (HistoryPanel + auto-log) .. 12.0/1         ║
// ║   • fulltext hľadanie v zozname .................. sek. 56        ║
// ║   • SearchableSelect (žiadny plain <select>) ..... sek. 56.11     ║
// ║   • TINT pozadia (žiadne inline farby) ........... sek. 21.15     ║
// ║   • dedup kontrola (409 z backendu) .............. sek. 13        ║
// ║   • klávesnica (mod+N, /) + cheatsheet ........... sek. 54        ║
// ║   • breadcrumb — rieši Layout .................... sek. 53.2      ║
// ╚══════════════════════════════════════════════════════════════════╝

import HelpHint from '../components/HelpHint.jsx'   // hinty_v1: obrazovka nemala ani jednu nápovedu
import React, { useState, useMemo, useEffect, useCallback, useRef } from 'react'
import TelefonInput from '../components/TelefonInput.jsx'
import useLiveRefresh from '../hooks/useLiveRefresh.js'
import { COLORS, TYPO, SPACE, RADIUS, TINT, SK, hladaj } from '../theme.js'
import {
  PageHeader, MasterDetail, SearchInput, ListRow, ListStatusBar,
  FilterChips, KpiRow, KpiCard, Tabs, EmptyPane, SearchableSelect, DetailRow } from '../components/Ui.jsx'
import { Modal } from '../components/Modal.jsx'
import { Btn, BtnAdd, BtnGhost } from '../components/Btn.jsx'
import { HistoryPanel } from '../components/HistoryPanel.jsx'
import { useToast } from '../components/Toast.jsx'
import { useShortcuts } from '../hooks/useShortcuts.js'
import { useRecordEditor } from '../hooks/useRecordEditor.js'
import { useListKeyboard } from '../hooks/useListKeyboard.js'
import { usePositionMemory } from '../hooks/usePositionMemory.js'
import { useAuth } from '../auth/AuthContext.jsx'
import { fetchAuth } from '../auth/fetchAuth.js'
import { adresaRozloz, adresaZRegistra } from '../lib/adresa.js'   // PARTNER_ADRESA_V1: jeden pomocník adresy pre celý Matrix (0.J)
import AdresaBunky from '../components/AdresaBunky.jsx'   // ADRESA_BUNKY_V1: jeden blok adresy (0.J)
import ZMksoftuPanel from '../components/ZMksoftuPanel.jsx'   // ZAMESTNANEC_MKSOFT_V1
import MksoftParovanieFront from '../components/MksoftParovanieFront.jsx'   // ZAMESTNANEC_OSOBA_V1
import { StitokVazby, useStavVazieb } from '../components/ParovanieMKsoft.jsx'   // ZAMESTNANCI_MOCKUP_V1: spoločný stav väzby (osoba v mzdách ALEBO firma s IČO), nervová sústava 2525
import { MksoftAkoToFunguje } from '../components/MksoftParovanieFront.jsx'   // ZAMESTNANCI_MOCKUP_V1
import SmsButton from '../components/SmsButton.jsx'
import { useSkupinaColors } from '../utils/skupinaColors.js'
import { jeSubdodavka, chybySubdodavky, PLATBY_SUBDODAVKY, TYP_SUBDODAVKA, inyPartakPartie } from '../utils/subdodavka.js'
import { navrhPartie } from '../utils/partia.js'
import AttachmentsPanel from '../components/AttachmentsPanel.jsx'
import PodpisDokumentyPanel from '../components/PodpisDokumentyPanel.jsx'   // podpis_dok_v1
import DokumentyZamestnanca from '../components/DokumentyZamestnanca.jsx'   // DOKUMENTY_V1
import RowMenu from '../components/RowMenu.jsx'
import ExportMenu from '../components/ExportMenu.jsx'
import useSortable from '../hooks/useSortable.js'
import { useConfirm } from '../components/ConfirmDialog.jsx'
import { usePinGate } from '../hooks/usePinGate.jsx'
import useOdlozene from '../hooks/useOdlozene.js'   // zoznam_plynuly_v1

// ╔═══ KONFIGURÁCIA MODULU — VYPLŇ PRI KOPÍROVANÍ ═══════════════════╗
// DÔLEŽITÉ: resource MUSÍ byť presne cesta API segmentu (napr. 'work-schedule'
// pre /api/work-schedule). Server zapisuje audit pod týmto názvom — ak sa
// nezhoduje, HistoryPanel nenájde históriu (ústava-review 9.D.3).
const CFG = {
  resource:    'employees',
  apiBase:     '/api/employees',
  titlePlural: 'Zamestnanci',
  newLabel:    'Nový zamestnanec',
}

// Polia pre DIFF (ústava 53.8) — useRecordEditor ich porovná initial vs. zmenené.
// label = ako sa pole volá v Confirm prehľade. format = voliteľné zobrazenie.
const EDIT_FIELDS = [
  { name: 'titul',         label: 'Titul' },          // podpisy_v1 (Mirko 24. 9. 2026)
  { name: 'firstName',     label: 'Meno' },
  { name: 'lastName',      label: 'Priezvisko' },
  { name: 'birth_date',    label: 'Dátum narodenia' },
  { name: 'doklad_cislo',  label: 'Číslo OP / vodičského preukazu' },
  { name: 'datum_nastupu', label: 'Dátum nástupu do firmy' },
  { name: 'adresa',        label: 'Adresa trvalého pobytu' },
  { name: 'adresa_ulica',  label: 'Ulica' },          // ZAMESTNANEC_ADRESA_V1 (Mirko 20. 10. 2026): adresa v bunkách
  { name: 'adresa_cislo',  label: 'Číslo domu' },
  { name: 'adresa_psc',    label: 'PSČ' },
  { name: 'adresa_obec',   label: 'Obec' },
  { name: 'adresa_stat',   label: 'Štát' },
  { name: 'rodne_cislo',   label: 'Rodné číslo' },
  { name: 'is_partak',     label: 'PARŤÁK' },
  { name: 'sofer_zastup',  label: 'Môže zaskakovať ako šofér' },
  { name: 'category',      label: 'Kategória' },
  { name: 'role',          label: 'Rola' },
  { name: 'party',         label: 'Partia' },
  { name: 'payType',       label: 'Typ mzdy' },
  { name: 'rate',          label: 'Sadzba' },
  { name: 'phone',         label: 'Telefón' },
  { name: 'funkcia',       label: 'Funkcia (v podpise)' },   // podpisy_v1
  { name: 'email',         label: 'E-mail' },   // p107 (Mirko 22. 9. 2026 „áno") — jediné miesto pre e-mail zamestnanca; Kontakty ho čítajú odtiaľto
  { name: 'uvazok',        label: 'Úväzok' },
  { name: 'nationality',   label: 'Národnosť' },
  { name: 'employee_type', label: 'Typ zamestnania' },
  { name: 'ico',           label: 'IČO' },
  { name: 'firma',         label: 'Firma (partner)' },
  { name: 'ic_dph',        label: 'IČ DPH' },
  { name: 'dic',           label: 'DIČ' },
  { name: 'notes',         label: 'Poznámka' },
  // 🔴 Mirko 2026-08-05 (nedá sa uložiť zmena údajov pri zamestnancovi): tieto dve polia sa vo formulári
  // MENIA, ale v DIFF chýbali — useRecordEditor to vyhodnotil ako „Žiadne zmeny — nie je čo uložiť"
  // a zmenu ticho zahodil. PRAVIDLO: čo sa dá v editore zmeniť (ed.set), MUSÍ byť v EDIT_FIELDS.
  { name: 'milestone_m2',   label: 'Míľnik m²/mesiac (bonus)' },
  { name: 'manual_payroll', label: 'Réžia — ručné zadanie mzdy', format: (v) => (v ? 'áno' : 'nie') },
  { name: 'attendance_required', label: 'Dochádzka (príchod a odchod v mobile)', format: (v) => (v ? 'áno' : 'nie') },   // dochadzka_v1 (Mirko 25. 9. 2026)
  { name: 'rates',         label: 'Sadzby a príplatky',
    format: (r) => Array.isArray(r) && r.length > 0
      ? r.map(x => `${x.label || '—'} ${Number(x.amount || 0).toFixed(2)} ${x.unit || ''}`).join(' · ')
      : '— bez sadzieb —' },
]

// Národnosti — určujú jazyk v mobilnej apke + auto-preklad denníka (ústava 4)
const NATIONALITIES = [
  { value: 'SK', label: 'Slovensko (SK)' },
  { value: 'CZ', label: 'Česko (CZ)' },
  { value: 'PL', label: 'Poľsko (PL)' },
  { value: 'UA', label: 'Ukrajina (UA)' },
  { value: 'AL', label: 'Albánsko (AL)' },
  { value: 'HU', label: 'Maďarsko (HU)' },
  { value: 'RO', label: 'Rumunsko (RO)' },
  { value: 'SR', label: 'Srbsko (SR)' },
  { value: 'BG', label: 'Bulharsko (BG)' },
  { value: 'MK', label: 'Macedónsko (MK)' },
  { value: 'RU', label: 'Rusko (RU)' },
  { value: 'DE', label: 'Nemecko (DE)' },
  { value: 'EN', label: 'Anglicky (EN)' },
]
const flagOf = (code) => (NATIONALITIES.find(n => n.value === (code || '').toUpperCase()) || {}).label || code

// Filter chips (ústava 21.15 — farby gest). key 'all' = bez filtra.
const STATUS_FILTERS = [
  { key: 'all',     label: 'Všetci',    color: COLORS.muted },
  { key: 'active',  label: 'Aktívni',   color: COLORS.add },
  { key: 'partaci', label: 'Parťáci',   color: COLORS.total },
  { key: 'termin',  label: 'Ukončení',  color: COLORS.muted },
]

// ══════════════════════════════════════════════════════════════════
// HLAVNÝ KOMPONENT — master-detail stránka (ústava sek. 56)
// ══════════════════════════════════════════════════════════════════
// noDiacritics — odstráni diakritiku z reťazca (pre vyhľadávanie SK/PL/CZ/UA)
function noDiacritics(s) {
  if (!s) return ''
  return s.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

export default function ZamestnanciView() {
  const { user } = useAuth()                 // user pre LOCK (53.7)
  const toast = useToast()
  // ZAMESTNANCI_OCHRANA_V1 (Mirko 27. 10. 2026: „ZABRÁNIL BY SOM KOPÍROVANIU OSOBNÝCH ÚDAJOV ALE IBA ZAMESTNANCOV, MÔŽEM IBA ADMIN KONATEĽ“)
  const smieKopirovat = ['admin', 'owner'].includes(String(user?.role || ''))
  const strazKopirovania = (e) => {
    const txt = String((window.getSelection && window.getSelection()) || '')
    if (!txt.trim()) return
    fetchAuth('/api/employees/kopirovanie', { method: 'POST', body: JSON.stringify({ znakov: txt.length, kde: 'Zamestnanci' }) }).catch(() => {})
    if (!smieKopirovat) { e.preventDefault(); toast.error ? toast.error('Osobné údaje zamestnancov kopíruje len admin a konateľ. Pokus je zaznamenaný.') : toast.show('Osobné údaje zamestnancov kopíruje len admin a konateľ.', 'error') }
  }
  const confirm = useConfirm()
  const pinGate = usePinGate()
  const skupinaColor = useSkupinaColors()    // farby skupín zhodné s DB schedule_groups

  // ── pamäť pozície (ústava 53.3) — obnoví výber / filter / hľadanie / scroll ──
  const pos = usePositionMemory(CFG.resource)
  const listRef = useRef(null)

  const [rows, setRows]       = useState([])
  const [loading, setLoading] = useState(true)
  const [search, setSearch]   = useState(pos.filter?.search || '')
  const [filter, setFilter]   = useState(pos.filter?.status || 'all')
  const [selectedId, setSelectedId] = useState(pos.selectedRow || null)
  const [modal, setModal]     = useState(null)  // null | {record} | {record:null}
  const [partyWizard, setPartyWizard] = useState(null)  // ⋮ Vytvoriť partiu (row)
  const [joinParty, setJoinParty]     = useState(null)  // ⋮ Pridať do partie (row)
  // ZAMESTNANEC_OSOBA_V1: stav väzby na MKsoft (štítok v zozname) + front na spárovanie (len vedenie, office, účtovníčka)
  const [mkObnov, setMkObnov] = useState(0)   // ZAMESTNANCI_MOCKUP_V1
  const mkIds = useMemo(() => rows.map(r => r.id), [rows])
  const mkStav = useStavVazieb('zamestnanec', mkIds, mkObnov)
  const [mkFilter, setMkFilter] = useState('')
  const [mkAko, setMkAko] = useState(false)
  const [termRow, setTermRow] = useState(null)   // ZAMESTNANCI_UKONCIT_V1 (Mirko 21. 10.: „nefunguje ukoncit cez tri bodky“)
  const [mkFront, setMkFront] = useState(false)
  const mkSmie = ['admin', 'owner', 'owner_view', 'office_manager', 'accountant'].includes((user && user.role) || '')
  const mkNacitaj = useCallback(() => setMkObnov(x => x + 1), [])

  // ── načítanie dát ────────────────────────────────────────────────
  const load = useCallback(async () => {
    setLoading(true)
    try {
      const r = await fetchAuth(CFG.apiBase)
      const d = await r.json()
      setRows(Array.isArray(d) ? d : (d.rows || []))
      setMkObnov(x => x + 1)   // ZAMESTNANCI_STITOK_OBNOV_V1 (Mirko 21. 10.: „galovu jana som spároval a zostala ako návrh na modro“): štítok MKsoft po každom načítaní
    } catch (_) {
      toast.error('Dáta sa nenačítali.')
    } finally {
      setLoading(false)
    }
  }, [toast])

  useEffect(() => { load() }, [load])
  useLiveRefresh(load)  // živé obnovenie (SSE, ústava 97)

  // Sync pamäť výberu — keď sa zmení selectedId, ulož do pos
  useEffect(() => {
    if (pos.setSelected && selectedId) pos.setSelected(selectedId)
  }, [selectedId, pos.setSelected])

  // ── filter + fulltext hľadanie (ústava sek. 56, diakritika-insensitive) ──
  const filtered = useMemo(() => {
    const q = noDiacritics(search.trim().toLowerCase())
    return rows.filter(row => {
      if (filter === 'active' && !row.active) return false
      if (filter === 'termin' && row.active) return false
      if (filter === 'partaci' && !row.is_partak) return false
      if (mkFilter && ((mkStav[row.id] || {}).stav || 'no') !== mkFilter) return false   // ZAMESTNANCI_MOCKUP_V1
      if (!q) return true
      // hľadá vo všetkých textových poliach záznamu
      return Object.values(row).some(v =>
        v != null && noDiacritics(String(v).toLowerCase()).includes(q))
    })
  }, [rows, search, filter, mkFilter, mkStav])
  const sortable = useSortable(filtered)

  // zoznam_plynuly_v1: detail nedrzi krok s kurzorom — dokresli sa, ked sa kurzor zastavi.
  // Zvyraznenie riadku v zozname ostava okamzite (cita selectedId), odlozeny je len pravy panel.
  const selectedIdDetail = useOdlozene(selectedId, 120)
  const selected = useMemo(
    () => rows.find(r => r.id === selectedIdDetail) || null,
    [rows, selectedIdDetail])

  // p103 (Mirko 22. 9. 2026: „prejsť rýchlo z kontaktu do zamestnanca alebo partnera"): ?open=<id> otvorí kartu
  const [openZKontaktov, setOpenZKontaktov] = useState(() => { try { return new URLSearchParams(window.location.search).get('open') } catch (_) { return null } })
  useEffect(() => {
    if (!openZKontaktov || !rows || !rows.length) return
    const r = rows.find(x => String(x.id) === String(openZKontaktov)); setOpenZKontaktov(null)
    if (r) { if (!r.active && filter === 'active') setFilter('all'); setSelectedId(r.id) }
  }, [rows])  // eslint-disable-line react-hooks/exhaustive-deps

  // ── pamäť pozície — zápis zmien (ústava 53.3) ────────────────────
  useEffect(() => { pos.selectRow(selectedId) }, [selectedId, pos.selectRow])
  useEffect(() => { pos.setFilter({ status: filter, search }) }, [filter, search, pos.setFilter])
  useEffect(() => {
    if (!loading && listRef.current) pos.restoreScroll(listRef.current)
  }, [loading])  // eslint-disable-line react-hooks/exhaustive-deps

  // ── klávesová navigácia zoznamu (ústava 54.2, 56.5) — zdieľaný hook ──
  const openRecord = useCallback((row) => setModal({ record: row }), [])
  useListKeyboard({
    items: filtered,
    selectedId,
    onSelect: setSelectedId,
    onOpen: openRecord,
    enabled: !modal,
  })

  // ── klávesové skratky (ústava sek. 54) ───────────────────────────
  useShortcuts([
    { keys: 'alt+n', label: CFG.newLabel, scope: CFG.resource,
      handler: () => setModal({ record: null }) },
    { keys: '/', label: 'Hľadať', scope: CFG.resource, handler: () => {
      const el = document.querySelector(`[data-${CFG.resource}-search]`)
      if (el) el.focus()
    } },
  ])

  // ── KPI súhrn (ústava sek. 56.8) ─────────────────────────────────
  const kpi = useMemo(() => ({
    total:   rows.length,
    active:  rows.filter(r => r.active).length,
    partaci: rows.filter(r => r.is_partak && r.active).length,
  }), [rows])

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, ...(smieKopirovat ? {} : { userSelect: 'none', WebkitUserSelect: 'none' }) }} onCopy={strazKopirovania} onCut={strazKopirovania}>
      <PageHeader title={CFG.titlePlural} subtitle={`${filtered.length} z ${rows.length}`}>
      <HelpHint section="11" text="ČO: zoznam ľudí, s ktorými firma reálne robí — zamestnanci, SZČO aj subdodávky; karta drží meno, telefón, národnosť, skupinu, partiu a označenie PARŤÁK. PREČO: karta je jediné miesto, odkiaľ si Rozpis prác, Mzdy, Dochádzka a podpisy v dokumentoch berú človeka — čo chýba tu, chýba aj tam. KAM: vyplnená Skupina plus zaškrtnutý PARŤÁK posunú človeka do Rozpisu prác a otvoria mu denník na mobile; Titul a Funkcia idú do podpisu e-mailov a dokumentov; Národnosť určuje jazyk denníka; prepínač Dochádzka zapne príchod a odchod v mobile. Peniaze tu nie sú: Sadzba v Detaile aj tab Sadzby sú len zapísané dohody a Matrix z nich nikde nič nepočíta (Sadzba v Detaile sa navyše ukáže len ako číslo s €, bez jednotky) — zárobok partie, zálohy a výplaty vznikajú v Mzdách 2026 v knihe partie. Sem nepatrí vyplácanie a zrážky (Mzdy 2026, kniha partie, tlačidlo Vyplatiť) ani zakladanie konta a PIN (Nastavenia, Používatelia a PIN). Ak si filter nezmenil, zoznam stojí na Všetci, takže sú v ňom aj ukončení ľudia — sú zosvetlení a zaradení na konci; kachlička Spolu je počet všetkých kariet, skutočný stav je Aktívni. Ukončiť pracovný pomer sa robí po jednom v karte a pri parťákovi to nie je otázka naozaj, ale odovzdanie jeho budúcich priradení v Rozpise náhradníkovi z tej istej partie." />   {/* hinty_v1 */}
        {mkSmie && <Btn variant="nav" onClick={() => setMkFront(true)}>Párovanie s MKsoftom</Btn>}   {/* ZAMESTNANEC_OSOBA_V1 */}
        <Btn variant="ghost" onClick={() => setMkAko(true)}>Ako to funguje</Btn>   {/* ZAMESTNANCI_MOCKUP_V1 */}
        <BtnAdd onClick={() => setModal({ record: null })}>+ {CFG.newLabel}</BtnAdd>
      </PageHeader>

      <KpiRow cols={3}>
        <KpiCard title="Spolu" color={COLORS.nav} value={kpi.total} />
        <KpiCard title="Aktívni" color={COLORS.add} value={kpi.active} />
        <KpiCard title="Parťáci" color={COLORS.total} value={kpi.partaci} />
      </KpiRow>

      <div style={{ height: SPACE.md }} />

      <MasterDetail
        left={
          <>
            <SearchInput value={search} onChange={setSearch}
              dataAttr={`data-${CFG.resource}-search`}
              placeholder="Hľadať (stlač /)…" />
            <div style={{ padding: '4px 10px', borderBottom: `1px solid ${COLORS.line}`,
              display: 'flex', alignItems: 'center', gap: 6, fontSize: TYPO.sizes.xs, color: COLORS.muted,
              flexWrap: 'wrap' }}>
              <span>Zoradiť:</span>
              {[
                // zoradenie_v1 (Mirko 13. 10. 2026: „chýba zoradiť napr. od najnovsích")
                { key: 'created_at', label: 'Najnovší' },
                { key: 'name', label: 'Meno' },
                { key: 'category', label: 'Skupina' },
                { key: 'party', label: 'Partia' },
                { key: 'role', label: 'Rola' },
                { key: 'id', label: 'ID' },
              ].map(c => {
                const ind = sortable.sortIndicator(c.key)
                return (
                  <button key={c.key} onClick={(e) => sortable.sortClick(c.key)(e)}
                    title="Klik = zoradiť, Shift+klik = pridať druhý kľúč"
                    style={{
                      padding: '2px 8px', background: ind ? COLORS.navBg : 'transparent',
                      border: `1px solid ${ind ? COLORS.brand : COLORS.line}`,
                      borderRadius: RADIUS.full, cursor: 'pointer',
                      fontSize: TYPO.sizes.xs, color: ind ? COLORS.brand : COLORS.muted,
                      fontFamily: 'inherit',
                    }}>{c.label}{ind ? ' ' + ind : ''}</button>
                )
              })}
            </div>
            <FilterChips options={STATUS_FILTERS} value={filter} onChange={setFilter} />
            <div style={{ padding: '4px 10px', borderBottom: `1px solid ${COLORS.line}` }}>   {/* ZAMESTNANCI_MOCKUP_V1: filter väzby na MKsoft */}
              <select value={mkFilter} onChange={e => setMkFilter(e.target.value)} style={{ padding: '4px 8px', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, fontFamily: 'inherit', fontSize: TYPO.sizes.xs, background: COLORS.bg }}>
                <option value="">MKsoft: všetci</option><option value="ok">MKsoft: spárovaní</option><option value="nv">MKsoft: návrh</option><option value="no">MKsoft: bez väzby</option>
              </select>
            </div>
            <div ref={listRef}
              onScroll={e => pos.saveScroll(e.currentTarget.scrollLeft, e.currentTarget.scrollTop)}
              style={{ flex: 1, overflow: 'auto', padding: 6 }}>
              {loading ? (
                <div style={{ padding: SPACE.lg, color: COLORS.muted, fontSize: TYPO.sizes.sm }}>
                  Načítavam…
                </div>
              ) : filtered.length === 0 ? (
                <div style={{ padding: SPACE.lg, color: COLORS.muted, fontSize: TYPO.sizes.sm }}>
                  Žiadne záznamy.
                </div>
              ) : [...sortable.sorted].sort((x, y) => ((x.active ? 0 : 1) - (y.active ? 0 : 1))).map(row => (
                <ListRow key={row.id}
                  dataId={row.id}
                  selected={row.id === selectedId}
                  stripColor={skupinaColor(row.category, row.role, COLORS.line)}
                  onClick={() => setSelectedId(row.id)}
                  onDoubleClick={() => setModal({ record: row })}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', gap: 6, alignItems: 'center', opacity: (row.active === 0 || row.active === '0') ? 0.4 : 1 }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      {/* zam_riadok_v1 (Mirko 15. 10. 2026: „Prvý riadok celé meno a priezvisko, druhý riadok funkcia"):
                          predtým boli meno aj funkcia v jednom riadku s nowrap a funkcia sa nesmela zmenšiť,
                          takže sa krátilo MENO — v zozname stálo „Jana …" a „Marek H…". Podľa Cenových ponúk:
                          meno sa zalomí, nikdy sa neoreže. */}
                      <div style={{
                        display: 'flex', alignItems: 'center', gap: SPACE.xs,
                        fontWeight: TYPO.weights.semibold, color: COLORS.text,
                        whiteSpace: 'normal', wordBreak: 'break-word',
                      }}>
                        {row.is_partak ? <span title="Parťák — vedie partiu, píše denník"
                          style={{ color: COLORS.total, fontSize: TYPO.sizes.md, flexShrink: 0, lineHeight: 1 }}>&#9679;</span> : null}
                        <span>{[row.titul, `${row.firstName || ''} ${row.lastName || ''}`.trim()].filter(Boolean).join(' ') || row.name || '(bez mena)'}</span>
                      </div>
                      {/* ZAMESTNANCI_MOCKUP_V1 (mockup 2519): druhý riadok funkcia · partia · nar. rok — rok rozlíši otca a syna rovnakého mena */}
                      <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: 1 }}>
                        {[row.funkcia || row.category, row.party, /^\d{4}/.test(String(row.birth_date || '')) ? 'nar. ' + String(row.birth_date).slice(0, 4) : ''].filter(Boolean).join(' · ') || row.id}
                      </div>
                    </div>
                    <div style={{ flexShrink: 0, textAlign: 'right', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4 }}>
                      <StatusTag status={row.category || row.role} active={row.active} />
                      {mkStav[row.id] && <StitokVazby s={mkStav[row.id]} />}   {/* ZAMESTNANEC_OSOBA_V1 */}
                      {row.nationality && row.nationality !== 'SK' && (
                        <span title={'Národnosť: ' + row.nationality}
                          style={{ fontSize: TYPO.sizes.sm }}>{(flagOf(row.nationality) || '').split(' ')[0]}</span>
                      )}
                      <RowMenu actions={[
                        { key: 'edit',  label: 'Upraviť',         onClick: () => setModal({ record: row }) },
                        ...(!row.is_partak ? [
                          { key: 'party', label: 'Vytvoriť partiu (tento = parťák)', onClick: () => setPartyWizard(row) },
                          { key: 'join',  label: 'Pridať do partie…', onClick: () => setJoinParty(row) },
                        ] : []),
                        // zoznam_plynuly_v1: „Tlačiť kartu" a „Uložiť ako PDF" boli mŕtve — natívny alert
                        // „pripravujeme". Tlačidlo, ktoré nič nerobí, klame; preč, kým tlač karty nebude.
                        { key: 'pin',   label: 'Prideliť/zmeniť PIN', onClick: () => toast.info('PIN sa prideľuje v Nastaveniach → Používatelia a PIN') },
                        { separator: true },
                        { key: 'term',  label: 'Ukončiť pracovný pomer', danger: true, onClick: async () => {
                        // PIN guard — ukončenie PP je vážna operácia
                        const gate = await pinGate('hard_delete', {
                          operacia: 'Ukončenie pracovného pomeru',
                          zamestnanec: row.name || row.id,
                        })
                        if (!gate || !gate.ok) return
                        setTermRow(row)   // ZAMESTNANCI_UKONCIT_V1: po PIN-e rovno okno Ukončiť pracovný pomer
                      } },
                      ]} />
                    </div>
                  </div>
                </ListRow>
              ))}
            </div>
            <ListStatusBar>
              ↑↓ výber · Enter detail · Alt+N nový · / hľadať
            </ListStatusBar>
          </>
        }
        right={
          selected
            ? <DetailPane record={selected} onEdit={() => setModal({ record: selected })} onReload={load} />
            : <EmptyPane text="Vyber záznam zo zoznamu vľavo" />
        }
      />

      {mkFront && <MksoftParovanieFront open onClose={() => { setMkFront(false); mkNacitaj() }} onOpen={id => { setMkFront(false); setSelectedId(id); mkNacitaj() }} />}   {/* ZAMESTNANEC_OSOBA_V1 */}
      {termRow && <TerminateDialog employee={termRow} onClose={() => setTermRow(null)} onDone={() => { setTermRow(null); load() }} />}   {/* ZAMESTNANCI_UKONCIT_V1 */}
      {mkAko && <MksoftAkoToFunguje open onClose={() => setMkAko(false)} />}   {/* ZAMESTNANCI_MOCKUP_V1 */}
      {partyWizard && (
        <PartiaWizard row={partyWizard} onClose={() => setPartyWizard(null)}
          onDone={() => { setPartyWizard(null); load() }} />
      )}
      {joinParty && (
        <JoinPartyModal row={joinParty} onClose={() => setJoinParty(null)}
          onDone={() => { setJoinParty(null); load() }} />
      )}
      {modal && (
        <RecordModal
          open
          record={modal.record}
          user={user}
          onClose={() => setModal(null)}
          onSaved={() => {
            setModal(null)
            load()
            toast.success('Uložené.')
          }}
        />
      )}
    </div>
  )
}

// ══════════════════════════════════════════════════════════════════
// STATUS TAG — farebný štítok stavu (ústava 21.15 — z TINT, nie inline)
// ══════════════════════════════════════════════════════════════════
function StatusTag({ status, active = true }) {
  return (
    <span style={{
      fontSize: TYPO.sizes.xs,
      fontWeight: TYPO.weights.semibold,
      color: active ? COLORS.nav : COLORS.muted,
      background: active ? COLORS.navBg : COLORS.lineSoft,
      borderRadius: RADIUS.sm,
      padding: '1px 7px',
      opacity: active ? 1 : 0.6,
    }}>{status || '—'}</span>
  )
}

// ══════════════════════════════════════════════════════════════════
// DETAIL PANE — pravá strana, taby Detail / História (ústava sek. 56)
// ══════════════════════════════════════════════════════════════════
// ── TerminateDialog (ústava 1 soft archív + sek. 3 parťák + Rozpis vlákno) ─
function TerminateDialog({ employee, onClose, onDone }) {
  const [preview, setPreview] = useState(null)
  const [reason, setReason] = useState('')
  const [busy, setBusy] = useState(false)
  const [replacementId, setReplacementId] = useState('')
  const [partyMates, setPartyMates] = useState([])
  const toast = useToast()
  useEffect(() => {
    fetchAuth(`/api/employees/${employee.id}/termination-preview`)
      .then(r => r.ok ? r.json() : null)
      .then(setPreview)
      .catch(() => {})
    // Ak je parťák, načítaj ostatných aktívnych zamestnancov v tej istej partii
    if (employee.is_partak && employee.party) {
      fetchAuth(`/api/parties/${employee.party}/employees`)
        .then(r => r.ok ? r.json() : [])
        .then(rows => setPartyMates((rows || []).filter(m => m.active && m.id !== employee.id)))
        .catch(() => {})
    }
  }, [employee.id, employee.is_partak, employee.party])

  async function execute() {
    setBusy(true)
    try {
      const r = await fetchAuth(`/api/employees/${employee.id}/terminate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ reason, replacement_employee_id: replacementId || '' }),
      })
      if (!r.ok) throw new Error('terminate failed')
      const d = await r.json()
      toast.success(`Ukončené. Rozpis: ${d.terminated_schedules || 0} priradení.`)
      if (onDone) onDone()
    } catch (e) {
      toast.error('Chyba pri ukončovaní')
    } finally {
      setBusy(false)
    }
  }

  return (
    <Modal open={true} title={`Ukončiť pracovný pomer — ${employee.name}`} onClose={onClose} width={560}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
        {!preview && <div style={{ color: COLORS.muted }}>Načítavam vlákno…</div>}
        {preview && (
          <>
            {preview.isPartak && (
              <div style={{
                padding: SPACE.md,
                background: 'rgba(245,158,11,0.12)',
                border: `1px solid ${COLORS.total}`,
                borderRadius: RADIUS.md,
              }}>
                <div style={{ fontWeight: TYPO.weights.bold, color: COLORS.total, marginBottom: 4 }}>
                  Tento zamestnanec je PARŤÁK
                </div>
                <div style={{ fontSize: TYPO.sizes.sm, color: COLORS.text }}>
                  Vedie partiu <b>{employee.party || '—'}</b>. Po ukončení sa odstráni z aktívneho Rozpisu prác.
                  Historické záznamy zostanú (ústava bod 1 — soft archív).
                </div>
              </div>
            )}
            {employee.linked_customer_id && (
              <div style={{
                padding: SPACE.md,
                background: 'rgba(59,130,246,0.08)',
                border: `1px solid ${COLORS.nav}`,
                borderRadius: RADIUS.md,
              }}>
                <div style={{ fontWeight: TYPO.weights.bold, color: COLORS.nav, marginBottom: 4 }}>
                  Tento SZČO je aj v Partneroch ({employee.linked_customer_id})
                </div>
                <div style={{ fontSize: TYPO.sizes.sm, color: COLORS.text }}>
                  <strong>Záznam partnera NEZMIZNE</strong> (ústava bod 1 — soft archív · môže pokračovať
                  ako dodávateľ FA aj po skončení zamestnaneckého pomeru). Ak chceš ukončiť
                  aj partnerskú spoluprácu, urob to manuálne v Partneroch.
                </div>
              </div>
            )}
            <div style={{ fontSize: TYPO.sizes.sm }}>
              Naozaj ukončiť pracovný pomer <b>{employee.name}</b>?
            </div>
            {preview.futureSchedules.length > 0 ? (
              <div style={{
                padding: SPACE.md, background: COLORS.bgSoft,
                border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md,
              }}>
                <div style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.bold,
                  color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '0.06em',
                  marginBottom: SPACE.sm }}>
                  Dotknuté priradenia v Rozpise ({preview.futureSchedules.length})
                </div>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: TYPO.sizes.sm }}>
                  <tbody>
                    {preview.futureSchedules.map(ws => (
                      <tr key={ws.id} style={{ borderBottom: `1px solid ${COLORS.lineSoft}` }}>
                        <td style={{ padding: '4px 6px', fontFamily: TYPO.mono, fontSize: TYPO.sizes.xs }}>
                          {ws.project_id}
                        </td>
                        <td style={{ padding: '4px 6px' }}>{ws.project_name}</td>
                        <td style={{ padding: '4px 6px', fontFamily: TYPO.mono, fontSize: TYPO.sizes.xs, color: COLORS.muted }}>
                          {ws.start_date} → {ws.end_date || '∞'}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: SPACE.sm }}>
                  Tieto priradenia sa skrátia na dnešný dátum (alebo zrušia ak ešte nezačali). História pred dnešnom zostane.
                </div>
              </div>
            ) : (
              <div style={{ fontSize: TYPO.sizes.sm, color: COLORS.muted }}>
                Žiadne aktívne/budúce priradenia v Rozpise — len zmena stavu na „Ukončený".
              </div>
            )}
            {preview.isPartak && partyMates.length > 0 && (
              <div style={{
                padding: SPACE.md,
                background: 'rgba(245,158,11,0.06)',
                border: `1px solid ${COLORS.line}`,
                borderRadius: RADIUS.md,
              }}>
                <div style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.bold,
                  color: '#f59e0b', textTransform: 'uppercase', letterSpacing: '0.06em',
                  marginBottom: 4 }}>
                  Nahradiť parťáka v partii „{employee.party}"
                </div>
                <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: SPACE.sm }}>
                  Aby partia nezostala bez vedúceho — vyberte kto preberie PARTAK flag.
                </div>
                <SearchableSelect
                  value={replacementId}
                  onChange={setReplacementId}
                  options={[
                    { value: '', label: '— bez náhradníka (partia ostane bez parťáka) —' },
                    ...partyMates.map(m => ({
                      value: m.id,
                      label: (m.name || `${m.firstName || ''} ${m.lastName || ''}`.trim()) + (m.role ? ` · ${m.role}` : ''),
                    }))
                  ]}
                  placeholder="Vyber náhradníka…" />
              </div>
            )}
            <div>
              <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 4 }}>
                Dôvod (voliteľne, zapíše sa do poznámky priradení)
              </div>
              <textarea value={reason} onChange={e => setReason(e.target.value)} rows={2}
                placeholder="napr. výpoveď zo strany zamestnanca / firmy, choroba…"
                style={{
                  width: '100%', padding: '8px 10px',
                  border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm,
                  fontSize: TYPO.sizes.sm, resize: 'vertical', background: COLORS.bg, color: COLORS.text,
                }} />
            </div>
          </>
        )}
        <div style={{ display: 'flex', gap: SPACE.sm, justifyContent: 'flex-end' }}>
          <BtnGhost onClick={onClose} disabled={busy}>Zrušiť</BtnGhost>
          <Btn variant="remove" onClick={execute} disabled={busy || !preview}>
            {busy ? 'Ukončujem…' : 'Áno, ukončiť pracovný pomer'}
          </Btn>
        </div>
      </div>
    </Modal>
  )
}

function DetailPane({ record, onEdit, onReload }) {
  const [tab, setTab] = useState('detail')
  const [showTerm, setShowTerm] = useState(false)
  const [showMerge, setShowMerge] = useState(false)
  const mkHlav = useStavVazieb('zamestnanec', record && record.id ? [record.id] : [], record)[record && record.id]   // ZAMESTNANCI_MOCKUP_V1: štítok pri mene · ZAMESTNANCI_STITOK_OBNOV_V1: obnoví sa s kartou
  const toast = useToast()

  async function restore() {
    try {
      const r = await fetchAuth(`/api/employees/${record.id}/restore`, { method: 'POST' })
      if (!r.ok) throw new Error('restore failed')
      toast.success('Pracovný pomer obnovený')
      if (onReload) onReload()
    } catch (e) {
      toast.error('Chyba pri obnovovaní')
    }
  }

  return (
    <div style={{
      background: COLORS.bg,
      border: `1px solid ${COLORS.line}`,
      borderRadius: RADIUS.lg,
      height: '100%',
      display: 'flex', flexDirection: 'column',
      overflow: 'hidden',
    }}>
      {/* HLAVIČKA KARTY — tenký stavový pásik + čierny názov (ústava 61.6) */}
      <div style={{ height: 4, background: COLORS.brand }} />
      <div style={{
        display: 'flex', alignItems: 'center', gap: SPACE.md, flexWrap: 'wrap',
        padding: `${SPACE.md}px ${SPACE.lg}px`,
        borderBottom: `1px solid ${COLORS.line}`,
      }}>
        <h2 style={{ margin: 0, fontSize: TYPO.sizes.lg, fontWeight: TYPO.weights.extra,
          color: COLORS.text }}>
          {record.name || '(bez názvu)'}
        </h2>
        <span style={{ color: COLORS.muted, fontSize: TYPO.sizes.sm }}>{[record.id, record.funkcia].filter(Boolean).join(' · ')}</span>   {/* ZAMESTNANCI_MOCKUP_V2: ako v mockupe */}
        {record.is_partak && (
          <span style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.bold,
            color: COLORS.total, background: TINT.total || 'rgba(245,158,11,0.12)',
            border: `1px solid ${COLORS.total}`, borderRadius: RADIUS.full,
            padding: '2px 8px' }}>PARŤÁK</span>
        )}
        <StatusTag status={record.category || record.role} active={record.active} />
        <div style={{ flex: 1 }} />
        {mkHlav && <StitokVazby s={mkHlav} />}   {/* ZAMESTNANCI_TAB_V1: štítok vpravo ako v mockupe 2519 */}
        <Btn variant="nav" onClick={onEdit}>Upraviť</Btn>
        <BtnGhost onClick={() => setShowMerge(true)} title="Zlúčiť s iným zamestnancom (pre duplikáty)">Zlúčiť</BtnGhost>
        {record.active
          ? <Btn variant="remove" onClick={() => setShowTerm(true)}>Ukončiť PP</Btn>
          : <Btn variant="add"  onClick={restore}>Obnoviť PP</Btn>}
      </div>

      <div style={{ padding: SPACE.md, overflow: 'auto', flex: 1, background: COLORS.bg,
        border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.lg }}>
        <Tabs
          value={tab}
          onChange={setTab}
          tabs={[
            { key: 'detail',     label: 'Detail' },
            { key: 'mksoft',     label: 'Z MKsoftu' },   // ZAMESTNANCI_MOCKUP_V1 — vlastná záložka (mockup 2519)
            { key: 'dokumenty',  label: 'Dokumenty' },   // DOKUMENTY_V1 — ten istý register, filtrovaný na zamestnanca
            { key: 'podpis',     label: 'Na podpis' },   // podpis_dok_v1 — režim B, ústava 141.1
            { key: 'history',    label: 'História' },
            { key: 'rates',      label: 'Sadzby' },
            { key: 'loans',      label: 'Požičané' },
            { key: 'partneri',   label: 'SZČO partneri' },
            { key: 'financny',   label: 'Finančný prehľad' },
            { key: 'doklady',    label: 'Doklady & foto' },
          ]}
        />
        {tab === 'detail' ? (
          // ZAMESTNANCI_MOCKUP_V2 (Mirko 21. 10.: „aj nový detail zamestnanca má racio starý je blbosť“, mockup 2519):
          // hore osobné údaje ako v mockupe (adresa v bunkách), pod nimi pracovné údaje v dvoch stĺpcoch — karta sa zmestí na obrazovku.
          <div style={{ fontSize: TYPO.sizes.base, lineHeight: 1.7 }}>
            <DetailRow label="Meno"           value={[record.titul, `${record.firstName || ''} ${record.lastName || ''}`.trim()].filter(Boolean).join(' ')} />
            <DetailRow label="Funkcia"        value={record.funkcia ? record.funkcia : <span style={{ color: '#b45309' }}>nevyplnená — v podpise e-mailov a dokumentov bude len meno</span>} />
            <DetailRow label="Dátum narodenia"value={record.birth_date} />
            <DetailRow label="Adresa trvalého pobytu" value={
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(90px, 1fr))', gap: 6, maxWidth: 640 }}>
                {[['Ulica', record.adresa_ulica], ['Číslo', record.adresa_cislo], ['PSČ', record.adresa_psc], ['Obec', record.adresa_obec], ['Štát', record.adresa_stat]].map(([l, v]) => (
                  <div key={l} style={{ border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, padding: '3px 8px', lineHeight: 1.35, minWidth: 0 }}>
                    <div style={{ fontSize: 10.5, color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '.04em' }}>{l}</div>
                    <div style={{ fontSize: TYPO.sizes.sm, overflow: 'hidden', textOverflow: 'ellipsis' }}>{v || <span style={{ color: COLORS.muted }}>—</span>}</div>
                  </div>))}
              </div>} />
            {record.rodne_cislo !== undefined && <DetailRow label="Rodné číslo" value={<span>{record.rodne_cislo || <span style={{ color: COLORS.muted }}>— (prevezme sa pri spárovaní s MKsoftom)</span>} <span style={{ marginLeft: 6, background: '#EEF0F3', color: COLORS.muted, borderRadius: 999, padding: '0 8px', fontSize: 11, fontWeight: 700 }}>len osobná zložka</span></span>} />}   {/* ZAMESTNANEC_ADRESA_V1: server ho pošle len osobnej zložke */}
            <DetailRow label="Číslo OP / VP"  value={record.doklad_cislo} />
            <DetailRow label="Nástup"         value={record.datum_nastupu} />
            <DetailRow label="Skupina"        value={record.category} />
            <DetailRow label="Partia"         value={record.party} />
            <DetailRow label="Telefón"        value={record.phone ? <span>{record.phone} <SmsButton to={record.phone} label="SMS" style={{ padding: '3px 11px', fontSize: 12, fontWeight: 700, border: '1px solid #86efac', background: '#f0fdf4', color: '#15803d', borderRadius: 8, marginLeft: 6 }} /></span> : record.phone} />
            {record.phone && <SmsHistoria phone={record.phone} />}
            <DetailRow label="E-mail"         value={record.email ? <a href={'mailto:' + record.email} style={{ color: 'inherit' }}>{record.email}</a> : ''} />
            <div style={{ fontSize: 11, fontWeight: 700, color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '.05em', margin: '14px 0 4px' }}>Práca a mzda</div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 260px), 1fr))', columnGap: SPACE.lg, fontSize: TYPO.sizes.sm, lineHeight: 1.5 }}>
              {[
                ['Typ zamestnania', record.employee_type === 'subdodavka' ? 'Subdodávka' : record.employee_type === 'szco' ? 'SZČO' : 'Zamestnanec'],
                ['Parťák', record.is_partak ? 'Áno (vedie partiu, píše denník)' : record.employee_type === 'subdodavka' ? 'Nie — člen partie' : 'Nie'],
                ['Rola', record.role],
                ['Typ úväzku', record.uvazok],
                ['Typ mzdy', record.payType],
                ['Sadzba', record.rate != null ? String(record.rate) + ' €' : ''],
                ['IČO', record.ico],
                ['Aj partner', record.linked_customer_id ? record.linked_customer_id + ' (SZČO je aj v Partneroch)' : ''],
                ['Firma (partner)', record.employee_type === 'subdodavka' ? [record.partner_nazov, record.partner_ic_dph || record.partner_dic].filter(Boolean).join(' · ') : ''],
                ['Národnosť', flagOf(record.nationality) || record.nationality],
                ['Stav', record.active ? 'Aktívny' : 'Ukončený'],
              ].filter(([, v]) => v !== '' && v != null).map(([l, v]) => (
                <div key={l} style={{ display: 'flex', gap: 8, padding: '3px 0', borderBottom: '1px dashed #F1F2F4', minWidth: 0 }}>
                  <span style={{ color: COLORS.muted, minWidth: 120 }}>{l}</span><span style={{ minWidth: 0, overflowWrap: 'anywhere' }}>{v}</span>
                </div>))}
            </div>
            {record.notes ? <DetailRow label="Poznámka" value={record.notes} /> : null}
          </div>
        ) : tab === 'rates' ? (
          <RatesView rates={record.rates || []} />
        ) : tab === 'loans' ? (
          <LoansView employeeId={record.id} />
        ) : tab === 'partneri' ? (
          <PartneriView employeeId={record.id} employee={record} />
        ) : tab === 'financny' ? (
          <FinancnyPrehlad employeeId={record.id} />
        ) : tab === 'mksoft' ? (
          <ZMksoftuPanel employee={record} onReload={onReload} vTabe />   // ZAMESTNANCI_MOCKUP_V1: záložka Z MKsoftu
        ) : tab === 'dokumenty' ? (
          <DokumentyZamestnanca employee={record} onPodpis={() => setTab('podpis')} />   // DOKUMENTY_V1
        ) : tab === 'podpis' ? (
          <PodpisDokumentyPanel employeeId={record.id} employeeName={[record.titul, `${record.firstName || ''} ${record.lastName || ''}`.trim()].filter(Boolean).join(' ') || record.name} />
        ) : tab === 'doklady' ? (
          <div style={{ paddingTop: SPACE.md }}>
            <AttachmentsPanel entityType="employee" entityId={record.id} />
          </div>
        ) : (
          // audit kto/čo/kedy (ústava 12.0 bod 1).
          // POZN: auto-audit zapisuje entity_id len pri PUT/PATCH/DELETE
          // (úpravy). CREATE má entity_id prázdny — kto vytvoril záznam
          // pribudne keď backend dostane logAudit() helper (ROADMAP, 9.D.6).
          <HistoryPanel module={CFG.resource} entityId={record.id} />
        )}
      </div>
      {showMerge && (
        <MergeDialog
          employee={record}
          onClose={() => setShowMerge(false)}
          onDone={() => { setShowMerge(false); if (onReload) onReload() }} />
      )}
      {showTerm && (
        <TerminateDialog
          employee={record}
          onClose={() => setShowTerm(false)}
          onDone={() => { setShowTerm(false); if (onReload) onReload() }}
        />
      )}
    </div>
  )
}

// ── Sadzby & príplatky (employee_rates) — RATES_UI_v1 ─────────────────────
const RATE_UNITS = [
  { value: '€/hod', label: '€/hod' },
  { value: '€/m²',  label: '€/m²' },
  { value: '€/deň', label: '€/deň' },
  { value: '€/mes', label: '€/mes' },
  { value: '€',     label: '€ (paušál)' },
]
const RATE_LABEL_DEFAULTS = [
  'Základná sadzba',
  'Príplatok — stropy',
  'Príplatok — steny',
  'Príplatok — hrúbka',
  'Príplatok — nadčas',
  'Príplatok — iné',
]

function RatesView({ rates }) {
  if (!rates || rates.length === 0) {
    return (
      <div style={{ padding: SPACE.md, color: COLORS.muted, fontSize: TYPO.sizes.sm }}>
        Žiadne sadzby. Pridajte ich v editácii zamestnanca.
      </div>
    )
  }
  return (
    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: TYPO.sizes.sm, marginTop: SPACE.sm }}>
      <thead>
        <tr style={{ borderBottom: `2px solid ${COLORS.line}` }}>
          <th title="Názov dohodnutej sadzby alebo príplatku, ako sa o ňom s človekom hovorí (Základná sadzba, Príplatok — stropy). Je to dohoda zapísaná na karte, nie podklad, z ktorého sa počíta výplata." style={{ padding: '6px 8px', textAlign: 'left', color: COLORS.muted, fontWeight: TYPO.weights.semibold, fontSize: TYPO.sizes.xs, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Položka</th>
          <th title="Cena za jednu jednotku zo stĺpca vedľa, nie suma, ktorú niekto dostal. Matrix ju nikde nesčítava ani z nej nepočíta mzdu — zárobok partie vzniká v Mzdách 2026 z výmery a sadzby bloku." style={{ padding: '6px 8px', textAlign: 'right', color: COLORS.muted, fontWeight: TYPO.weights.semibold, fontSize: TYPO.sizes.xs, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Suma</th>
          <th title="Za čo sadzba platí — €/hod, €/m², €/deň, €/mes alebo paušál. Bez jednotky je číslo nečitateľné; ten istý človek môže mať €/hod aj €/m² naraz." style={{ padding: '6px 8px', textAlign: 'left', color: COLORS.muted, fontWeight: TYPO.weights.semibold, fontSize: TYPO.sizes.xs, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Jednotka</th>
        </tr>
      </thead>
      <tbody>
        {rates.map(r => (
          <tr key={r.id} style={{ borderBottom: `1px solid ${COLORS.lineSoft}` }}>
            <td style={{ padding: '6px 8px' }}>{r.label || '—'}</td>
            <td style={{ padding: '6px 8px', textAlign: 'right', fontFamily: TYPO.mono, fontWeight: TYPO.weights.bold, color: COLORS.total }}>
              {Number(r.amount || 0).toFixed(2)}
            </td>
            <td style={{ padding: '6px 8px', color: COLORS.muted, fontFamily: TYPO.mono, fontSize: TYPO.sizes.xs }}>{r.unit || '—'}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

function RatesEditor({ value, onChange, readOnly }) {
  const rates = Array.isArray(value) ? value : []
  function update(i, patch) {
    const next = rates.slice()
    next[i] = { ...next[i], ...patch }
    onChange(next)
  }
  function add() {
    onChange([...rates, { label: '', amount: 0, unit: '€/hod' }])
  }
  function remove(i) {
    onChange(rates.filter((_, idx) => idx !== i))
  }
  const inputStyle = {
    width: '100%', padding: '4px 8px',
    border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm,
    fontSize: TYPO.sizes.sm, background: COLORS.bg, color: COLORS.text,
    boxSizing: 'border-box',
  }
  return (
    <div style={{
      padding: SPACE.md,
      background: COLORS.bgSoft,
      border: `1px solid ${COLORS.line}`,
      borderRadius: RADIUS.md,
    }}>
      <div style={{
        display: 'flex', alignItems: 'center', gap: SPACE.sm, marginBottom: SPACE.sm,
      }}>
        <div style={{
          fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.bold,
          color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '0.06em',
          flex: 1,
        }}>Sadzby a príplatky</div>
        {!readOnly && (
          <BtnAdd size="sm" onClick={add}>+ Pridať sadzbu</BtnAdd>
        )}
      </div>
      {rates.length === 0 ? (
        <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, fontStyle: 'italic' }}>
          Žiadne sadzby. Pridajte „Základnú sadzbu" + voliteľné príplatky (stropy / steny / hrúbka / nadčas).
        </div>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <tbody>
            {rates.map((r, i) => (
              <tr key={i}>
                <td style={{ padding: '4px 4px', width: '50%' }}>
                  <input type="text" value={r.label || ''} disabled={readOnly}
                    onChange={e => update(i, { label: e.target.value })}
                    placeholder={RATE_LABEL_DEFAULTS[i] || 'Názov sadzby'}
                    list={`rate-labels-${i}`}
                    style={inputStyle} />
                  <datalist id={`rate-labels-${i}`}>
                    {RATE_LABEL_DEFAULTS.map(d => <option key={d} value={d} />)}
                  </datalist>
                </td>
                <td style={{ padding: '4px 4px', width: '20%' }}>
                  <input type="number" step="0.01" value={r.amount || ''} disabled={readOnly}
                    onChange={e => update(i, { amount: Number(e.target.value) || 0 })}
                    style={{ ...inputStyle, textAlign: 'right', fontFamily: TYPO.mono }} />
                </td>
                <td style={{ padding: '4px 4px', width: '20%' }}>
                  <select value={r.unit || '€/hod'} disabled={readOnly}
                    onChange={e => update(i, { unit: e.target.value })}
                    style={inputStyle}>
                    {RATE_UNITS.map(u => <option key={u.value} value={u.value}>{u.label}</option>)}
                  </select>
                </td>
                <td style={{ padding: '4px 4px', width: '10%', textAlign: 'right' }}>
                  {!readOnly && (
                    <button type="button" onClick={() => remove(i)}
                      style={{ background: 'transparent', border: 'none', cursor: 'pointer',
                        color: COLORS.remove, fontSize: TYPO.sizes.md, padding: '2px 6px' }}
                      title="Odstrániť sadzbu">✕</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}
// ── /Sadzby ───────────────────────────────────────────────────────────────

// ── Tab Požičané (vozidlá + Požičovňa) — LOANS_UI_v1 ──────────────────────
function LoansView({ employeeId }) {
  const [loans, setLoans] = useState(null)
  useEffect(() => {
    fetchAuth(`/api/employees/${employeeId}/loans`)
      .then(r => r.ok ? r.json() : null)
      .then(setLoans)
      .catch(() => {})
  }, [employeeId])
  if (!loans) return <div style={{ padding: SPACE.md, color: COLORS.muted }}>Načítavam…</div>
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
      {/* VOZIDLÁ */}
      <div>
        <div style={{
          fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.bold,
          color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '0.06em',
          marginBottom: SPACE.sm,
        }}>Vozidlá pridelené tomuto zamestnancovi</div>
        {(loans.vehicles || []).length === 0 ? (
          <div style={{ padding: SPACE.md, color: COLORS.muted, fontSize: TYPO.sizes.sm,
            background: COLORS.bgSoft, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md }}>
            Žiadne pridelené vozidlá.
          </div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: TYPO.sizes.sm }}>
            <thead>
              <tr style={{ borderBottom: `2px solid ${COLORS.line}` }}>
                <th title="Auto, ktoré má človek pridelené. Pridelenie sa nastavuje v karte vozidla (Vozový park), v poli Pridelené zamestnancovi, nie tu." style={{ padding: '6px 8px', textAlign: 'left', color: COLORS.muted, fontSize: TYPO.sizes.xs, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Vozidlo</th>
                <th title="Značka vozidla z jeho karty. Slúži na rozlíšenie, keď má firma viac rovnakých áut." style={{ padding: '6px 8px', textAlign: 'left', color: COLORS.muted, fontSize: TYPO.sizes.xs, textTransform: 'uppercase', letterSpacing: '0.06em' }}>ŠPZ</th>
                <th title="Druh paliva prevzatý z karty vozidla. Je tu len na prečítanie — nič sa z neho na tejto obrazovke nepočíta." style={{ padding: '6px 8px', textAlign: 'left', color: COLORS.muted, fontSize: TYPO.sizes.xs, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Palivo</th>
                <th title="Dátum, odkedy auto patrí tomuto človeku. Pomlčka neznamená, že auto nemá — len že pridelenie nebolo zapísané s dátumom." style={{ padding: '6px 8px', textAlign: 'left', color: COLORS.muted, fontSize: TYPO.sizes.xs, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Pridelené od</th>
              </tr>
            </thead>
            <tbody>
              {loans.vehicles.map(v => (
                <tr key={v.id} style={{ borderBottom: `1px solid ${COLORS.lineSoft}` }}>
                  <td style={{ padding: '6px 8px', fontWeight: TYPO.weights.semibold }}>{v.name}</td>
                  <td style={{ padding: '6px 8px', fontFamily: TYPO.mono }}>{v.plate}</td>
                  <td style={{ padding: '6px 8px', color: COLORS.muted, fontSize: TYPO.sizes.xs }}>{v.fuel || '—'}</td>
                  <td style={{ padding: '6px 8px', fontFamily: TYPO.mono, fontSize: TYPO.sizes.xs, color: COLORS.muted }}>{v.assigned_at || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: SPACE.xs, fontStyle: 'italic' }}>
          Priradenie sa nastavuje v karte Vozidla (Vozový park) — pole „Pridelené zamestnancovi".
        </div>
      </div>

      {/* POŽIČOVŇA — náradie z loan_records */}
      <div>
        <div style={{
          fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.bold,
          color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '0.06em',
          marginBottom: SPACE.sm,
        }}>Náradie a stroje z Požičovne</div>
        {(loans.tools || []).length === 0 ? (
          <div style={{
            padding: SPACE.md, color: COLORS.muted, fontSize: TYPO.sizes.sm,
            background: COLORS.bgSoft, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md,
            fontStyle: 'italic',
          }}>
            {loans.tools_message || 'Žiadne aktívne výpožičky.'}
          </div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: TYPO.sizes.sm }}>
            <thead>
              <tr style={{ borderBottom: `2px solid ${COLORS.line}` }}>
                <th title="Náradie alebo stroj z Požičovne, ktoré má človek práve u seba. Tabuľka ukazuje len rozbehnuté výpožičky — výpožičku zakladá aj vracia Požičovňa, nie táto karta." style={{ padding: '6px 8px', textAlign: 'left', color: COLORS.muted, fontSize: TYPO.sizes.xs, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Položka</th>
                <th title="Výrobné číslo kusa, ak ho karta položky v Požičovni má. Pomlčka znamená, že kus sa podľa výrobného čísla nevedie." style={{ padding: '6px 8px', textAlign: 'left', color: COLORS.muted, fontSize: TYPO.sizes.xs, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Výr. č.</th>
                <th title="Číslo zákazky, na ktorú bol kus vypožičaný — zobrazuje sa kód, nie názov stavby. Pomlčka = kus je u človeka bez zákazky." style={{ padding: '6px 8px', textAlign: 'left', color: COLORS.muted, fontSize: TYPO.sizes.xs, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Zákazka</th>
                <th title="Dátum vypožičania. Čím starší dátum, tým skôr sa treba na kus spýtať — vrátenie sa zapisuje v Požičovni tlačidlom Vrátiť a riadok potom z tejto tabuľky zmizne." style={{ padding: '6px 8px', textAlign: 'left', color: COLORS.muted, fontSize: TYPO.sizes.xs, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Od</th>
              </tr>
            </thead>
            <tbody>
              {loans.tools.map(t => (
                <tr key={t.loan_id} style={{ borderBottom: `1px solid ${COLORS.lineSoft}` }}>
                  <td style={{ padding: '6px 8px', fontWeight: TYPO.weights.semibold }}>
                    {t.item_name} {t.item_code ? <span style={{ color: COLORS.muted, fontFamily: TYPO.mono, fontSize: TYPO.sizes.xs }}>({t.item_code})</span> : null}
                  </td>
                  <td style={{ padding: '6px 8px', fontFamily: TYPO.mono, fontSize: TYPO.sizes.xs, color: COLORS.muted }}>{t.serial_number || '—'}</td>
                  <td style={{ padding: '6px 8px', fontFamily: TYPO.mono, fontSize: TYPO.sizes.xs }}>{t.project_id || '—'}</td>
                  <td style={{ padding: '6px 8px', fontFamily: TYPO.mono, fontSize: TYPO.sizes.xs, color: COLORS.muted }}>{t.start_date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  )
}

// ── PartiaWizard — ⋮ „Vytvoriť partiu“: zamestnanec = parťák; povinná Skupina = kde partiu
//    uvidíš v Rozpise prác (stĺpec = parťák so Skupinou); členovia hneď pri vzniku.
//    Model ústavy: party kód + is_partak + category; kód = prefix podľa zvyklosti skupiny (PC/PS/PM/PP…).
//    PUT zamestnanca = VŽDY GET → merge → PUT (ústava 72 — full-replace).
function PartiaWizard({ row, onClose, onDone }) {
  const [groups, setGroups] = useState([])
  const [emps, setEmps] = useState([])
  const [skupina, setSkupina] = useState(row.category || '')
  const [name, setName] = useState('')
  const [menilNazov, setMenilNazov] = useState(false)   // p36: názov sa dopĺňa podľa pravidla, ručná zmena len vedome
  const [partie, setPartie] = useState([])
  const [color, setColor] = useState(PARTY_COLORS_PRESET[Math.floor(Math.random() * PARTY_COLORS_PRESET.length)])
  const [members, setMembers] = useState([])
  const [q, setQ] = useState('')
  const [busy, setBusy] = useState(false)
  const toast = useToast()

  useEffect(() => {
    Promise.all([
      fetchAuth('/api/schedule-groups').then(r => r.ok ? r.json() : []),
      fetchAuth('/api/employees').then(r => r.ok ? r.json() : []),
      fetchAuth('/api/parties').then(r => r.ok ? r.json() : []),
    ]).then(([g, e, p]) => {
      setGroups(Array.isArray(g) ? g : [])
      setEmps(Array.isArray(e) ? e : [])
      setPartie(Array.isArray(p) ? p : [])
    }).catch(() => {})
  }, [])

  // p36 (Mirko 17. 9. 2026): názov „Remeslo - Priezvisko parťáka“ a kód v rade remesla — jedno pravidlo pre celý Matrix (utils/partia.js)
  const navrh = useMemo(() => navrhPartie({ zamestnanec: { ...row, category: skupina }, zamestnanci: emps, partie, skupiny: groups }), [row, skupina, emps, partie, groups])
  const prefix = navrh.rad
  useEffect(() => { if (!menilNazov) setName(navrh.nazov) }, [navrh.nazov, menilNazov])

  // kandidáti na členov: aktívni, nie parťáci (parťák vedie vlastnú partiu), nie on sám
  const candidates = useMemo(() => {
    const s = q.trim().toLowerCase()
    return emps
      .filter(e => e.id !== row.id && !e.is_partak && e.active !== 0 && e.active !== '0')
      .filter(e => !s || hladaj((e.name || ''), s) || hladaj((e.id || ''), s))
      .sort((a, b) => (a.name || '').localeCompare(b.name || '', 'sk'))
  }, [emps, q, row.id])

  async function putEmployee(id, patch) {
    const r0 = await fetchAuth('/api/employees/' + id)
    if (!r0.ok) throw new Error('GET ' + id)
    const cur = await r0.json()
    const r = await fetchAuth('/api/employees/' + id, {
      method: 'PUT', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...cur, ...patch }),
    })
    if (!r.ok) throw new Error('PUT ' + id)
  }

  async function save() {
    if (!skupina) { toast.error('Vyber Skupinu — bez nej partiu v Rozpise prác neuvidíš (ústava 3).'); return }
    if (!name.trim()) { toast.error('Názov partie je povinný'); return }
    setBusy(true)
    try {
      const r = await fetchAuth('/api/parties', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ prefix, name: name.trim(), color, notes: '' }),
      })
      if (!r.ok) throw new Error('create party')
      const party = await r.json()
      await putEmployee(row.id, { party: party.id, is_partak: 1, category: skupina })
      let done = 0
      for (const mid of members) { await putEmployee(mid, { party: party.id }); done++ }
      toast.success('Partia ' + party.id + ' · ' + name.trim() + ' vytvorená — ' + (row.name || row.id) +
        ' je parťák' + (done ? ', členov: ' + done : '') + '. Uvidíš ju v Rozpise pod skupinou.')
      onDone()
    } catch (e) {
      toast.error('Nepodarilo sa dokončiť vytvorenie partie — over kartu zamestnanca a skús znova.')
    } finally { setBusy(false) }
  }

  const lbl = { fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 4, fontWeight: TYPO.weights.semibold, textTransform: 'uppercase', letterSpacing: '0.04em' }
  const inp = { width: '100%', padding: '8px 10px', border: '1px solid ' + COLORS.line, borderRadius: RADIUS.sm, fontSize: TYPO.sizes.sm, background: COLORS.bg, color: COLORS.text, boxSizing: 'border-box' }
  return (
    <Modal open={true} title={'Vytvoriť partiu — ' + (row.name || row.id)} onClose={onClose} width={480}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
        <div style={{ padding: SPACE.sm, background: 'rgba(59,130,246,0.06)', borderRadius: RADIUS.sm, fontSize: TYPO.sizes.xs, color: COLORS.muted, lineHeight: 1.5 }}>
          <b>{row.name}</b> sa stane <b>PARŤÁKOM</b> novej partie (každá partia má presne jedného parťáka — ústava).
          Partiu uvidíš v <b>Rozpise prác</b> pod zvolenou Skupinou.
        </div>
        <div>
          <div style={lbl}>Skupina * (pod ňou partia svieti v Rozpise)</div>
          <SearchableSelect value={skupina} onChange={setSkupina}
            options={groups.map(g => ({ value: g.id, label: g.label }))}
            placeholder="Vyber skupinu…" />
        </div>
        <div style={{ display: 'flex', gap: SPACE.md }}>
          <div style={{ flex: 1 }}>
            <div style={lbl}>Názov partie *</div>
            <input type="text" value={name} onChange={e => { setMenilNazov(true); setName(e.target.value) }} style={inp}
              title="Názov sa doplnil podľa pravidla „Remeslo - Priezvisko parťáka“ — meň len výnimočne" />
          </div>
          <div>
            <div style={lbl}>Kód</div>
            <div style={{ padding: '8px 10px', fontFamily: TYPO.mono, fontSize: TYPO.sizes.sm, color: COLORS.text, background: COLORS.lineSoft, borderRadius: RADIUS.sm }}
              title={'Ďalšie voľné číslo v rade ' + prefix + ' — pridelí sa pri uložení'}>{navrh.chyba ? prefix + '• auto' : navrh.kodNahlad}</div>
          </div>
          <div>
            <div style={lbl}>Farba</div>
            <input type="color" value={color} onChange={e => setColor(e.target.value)}
              style={{ width: 44, height: 34, border: '1px solid ' + COLORS.line, borderRadius: RADIUS.sm, cursor: 'pointer' }} />
          </div>
        </div>
        <div>
          <div style={lbl}>Členovia partie (voliteľné — {members.length} vybraných)</div>
          <input type="text" value={q} onChange={e => setQ(e.target.value)} placeholder="Hľadaj zamestnanca…" style={{ ...inp, marginBottom: 6 }} />
          <div style={{ maxHeight: 190, overflowY: 'auto', border: '1px solid ' + COLORS.line, borderRadius: RADIUS.sm }}>
            {candidates.map(e => (
              <label key={e.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 10px', cursor: 'pointer', borderBottom: '1px solid ' + COLORS.lineSoft, fontSize: TYPO.sizes.sm }}>
                <input type="checkbox" checked={members.includes(e.id)}
                  onChange={ev => setMembers(m => ev.target.checked ? [...m, e.id] : m.filter(x => x !== e.id))} />
                <span style={{ flex: 1 }}>{e.name || e.id}</span>
                <span style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, fontFamily: TYPO.mono }}>
                  {e.party ? 'teraz ' + e.party : '—'}
                </span>
              </label>
            ))}
            {candidates.length === 0 && <div style={{ padding: 10, fontSize: TYPO.sizes.xs, color: COLORS.muted }}>Nikto nezostáva — parťáci iných partií sa tu neponúkajú (zmena parťáka = karta zamestnanca).</div>}
          </div>
        </div>
        <div style={{ display: 'flex', gap: SPACE.sm, justifyContent: 'flex-end' }}>
          <BtnGhost onClick={onClose} disabled={busy}>Zrušiť</BtnGhost>
          <BtnAdd onClick={save} disabled={busy || !skupina || !name.trim()}>{busy ? 'Vytváram…' : 'Vytvoriť partiu'}</BtnAdd>
        </div>
      </div>
    </Modal>
  )
}

// ── JoinPartyModal — ⋮ „Pridať do partie“: rýchle priradenie člena k existujúcej partii
//    (ponúkajú sa LEN partie s aktívnym parťákom — ústava 3).
function JoinPartyModal({ row, onClose, onDone }) {
  const [parties, setParties] = useState([])
  const [val, setVal] = useState(row.party || '')
  const [busy, setBusy] = useState(false)
  const toast = useToast()
  useEffect(() => {
    fetchAuth('/api/parties').then(r => r.ok ? r.json() : []).then(p => setParties(Array.isArray(p) ? p : [])).catch(() => {})
  }, [])
  const opts = parties
    .filter(p => p.active !== 0 && (p.has_partak || p.id === row.party))
    .map(p => ({ value: p.id, label: (p.name || p.id) + ' (' + p.id + ')' + (p.partak_name ? ' — parťák ' + p.partak_name : '') }))
  async function save() {
    if (!val) { toast.error('Vyber partiu'); return }
    setBusy(true)
    try {
      const r0 = await fetchAuth('/api/employees/' + row.id)
      if (!r0.ok) throw new Error('get')
      const cur = await r0.json()
      const r = await fetchAuth('/api/employees/' + row.id, {
        method: 'PUT', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...cur, party: val }),
      })
      if (!r.ok) throw new Error('put')
      toast.success((row.name || row.id) + ' → partia ' + val)
      onDone()
    } catch (e) { toast.error('Nepodarilo sa uložiť — skús znova.') } finally { setBusy(false) }
  }
  return (
    <Modal open={true} title={'Pridať do partie — ' + (row.name || row.id)} onClose={onClose} width={440}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
        <SearchableSelect value={val} onChange={setVal} options={opts} placeholder="Vyber partiu…" />
        <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>
          Ponúkajú sa len partie s aktívnym parťákom. V Rozpise prác partiu vidíš pod Skupinou jej parťáka.
        </div>
        <div style={{ display: 'flex', gap: SPACE.sm, justifyContent: 'flex-end' }}>
          <BtnGhost onClick={onClose} disabled={busy}>Zrušiť</BtnGhost>
          <BtnAdd onClick={save} disabled={busy || !val}>{busy ? 'Ukladám…' : 'Pridať'}</BtnAdd>
        </div>
      </div>
    </Modal>
  )
}

// ── PartyCreateMini — inline modal "Nová partia" z karty zamestnanca ───────
const PARTY_COLORS_PRESET = [
  '#22c55e', '#f59e0b', '#3b82f6', '#ec4899', '#a78bfa',
  '#ef4444', '#0ea5e9', '#10b981', '#f97316', '#64748b',
]
function PartyCreateMini({ onClose, onCreated, zamestnanec }) {
  const [name, setName] = useState('')
  const [menilNazov, setMenilNazov] = useState(false)   // p36: názov sa dopĺňa sám podľa pravidla, ručná zmena len vedome
  const [data, setData] = useState({ zamestnanci: [], partie: [], skupiny: [] })
  const [color, setColor] = useState(PARTY_COLORS_PRESET[Math.floor(Math.random() * PARTY_COLORS_PRESET.length)])
  const [notes, setNotes] = useState('')
  const [busy, setBusy] = useState(false)
  const toast = useToast()
  useEffect(() => {
    Promise.all([
      fetchAuth('/api/employees').then(r => r.ok ? r.json() : []),
      fetchAuth('/api/parties').then(r => r.ok ? r.json() : []),
      fetchAuth('/api/schedule-groups').then(r => r.ok ? r.json() : []),
    ]).then(([e, p, g]) => setData({ zamestnanci: Array.isArray(e) ? e : [], partie: Array.isArray(p) ? p : [], skupiny: Array.isArray(g) ? g : [] }))
      .catch(() => {})
  }, [])
  // p36 (Mirko 17. 9. 2026 „automaticky doplniť názov partie, aby to malo logiku“): názov „Remeslo - Priezvisko parťáka“, kód v rade remesla
  const navrh = useMemo(() => navrhPartie({ zamestnanec, ...data }), [zamestnanec, data])
  useEffect(() => { if (!menilNazov) setName(navrh.nazov) }, [navrh.nazov, menilNazov])
  const z = zamestnanec || {}
  const menoZam = [z.firstName, z.lastName].filter(Boolean).join(' ') || z.name || 'Zamestnanec'
  async function save() {
    if (navrh.chyba) { toast.error(navrh.chyba); return }
    if (!name.trim()) { toast.error('Názov partie je povinný'); return }
    setBusy(true)
    try {
      // kód pridelí server: ďalšie voľné číslo v rade remesla (PS, PC, PM, PH, PP, PZ, PV)
      const r = await fetchAuth('/api/parties', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ prefix: navrh.rad, name: name.trim(), color, notes }),
      })
      if (!r.ok) throw new Error('save failed')
      const party = await r.json()
      toast.success('Partia ' + party.id + ' · ' + party.name + ' vytvorená — ' + menoZam + ' je jej parťák. Ulož kartu zamestnanca.')
      onCreated(party)
    } catch (e) {
      toast.error('Chyba pri vytváraní partie')
    } finally {
      setBusy(false)
    }
  }
  return (
    <Modal open={true} title="Nová partia" onClose={onClose} width={420}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
        <div style={{ padding: SPACE.sm, background: 'rgba(59,130,246,0.06)', borderRadius: RADIUS.sm,
          fontSize: TYPO.sizes.xs, color: COLORS.muted }}>
          Názov a kód sa doplnia <b>automaticky podľa pravidla</b>: „Remeslo - Priezvisko parťáka“ (napr. Sadra - Dziamko), kód v rade remesla
          (PS sadra, PC cement, PM maliari, PH hodinovkári, PP potery, PZ zatepľovači, PV šoféri). <b>{menoZam}</b> bude parťákom novej partie —
          partia bez parťáka sa v Rozpise prác neukáže (ústava 3).
        </div>
        {navrh.chyba && (
          <div style={{ padding: SPACE.sm, borderRadius: RADIUS.sm, background: COLORS.removeBg, color: COLORS.remove, fontSize: TYPO.sizes.sm }}>{navrh.chyba}</div>
        )}
        {!navrh.chyba && z.is_partak && z.party && (
          <div style={{ padding: SPACE.sm, borderRadius: RADIUS.sm, background: 'rgba(217,119,6,0.08)', color: COLORS.warn, fontSize: TYPO.sizes.sm }}>
            {menoZam} dnes vedie partiu {z.party}. Po uložení karty prejde do novej partie a stará ostane bez parťáka.
          </div>
        )}
        <div style={{ display: 'flex', gap: SPACE.md, alignItems: 'flex-start' }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 4, fontWeight: TYPO.weights.semibold, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Názov partie *</div>
            {menilNazov
              ? <input type="text" value={name} onChange={e => setName(e.target.value)} autoFocus
                  style={{ width: '100%', padding: '8px 10px', border: `1px solid ${COLORS.line}`,
                    borderRadius: RADIUS.sm, fontSize: TYPO.sizes.sm, background: COLORS.bg, color: COLORS.text, boxSizing: 'border-box' }} />
              : <div style={{ padding: '8px 10px', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, fontSize: TYPO.sizes.sm,
                  background: COLORS.lineSoft, color: name ? COLORS.text : COLORS.muted, minHeight: 18 }}>{name || '— doplní sa po výbere skupiny a mena —'}</div>}
            <button type="button" onClick={() => setMenilNazov(v => !v)} disabled={!!navrh.chyba}
              style={{ marginTop: 4, padding: 0, border: 'none', background: 'transparent', color: COLORS.info, fontSize: TYPO.sizes.xs,
                cursor: navrh.chyba ? 'default' : 'pointer', fontFamily: 'inherit' }}>
              {menilNazov ? 'Vrátiť názov podľa pravidla' : 'Upraviť názov (len výnimočne)'}
            </button>
          </div>
          <div>
            <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 4, fontWeight: TYPO.weights.semibold, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Kód</div>
            <div title="Ďalšie voľné číslo v rade remesla — pridelí sa pri uložení"
              style={{ padding: '8px 10px', fontFamily: TYPO.mono, fontSize: TYPO.sizes.sm, color: COLORS.text, background: COLORS.lineSoft, borderRadius: RADIUS.sm }}>
              {navrh.chyba ? '—' : navrh.kodNahlad}
            </div>
          </div>
        </div>
        <div>
          <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 4, fontWeight: TYPO.weights.semibold, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Farba (v Rozpise prác)</div>
          <div style={{ display: 'flex', gap: SPACE.sm, alignItems: 'center', flexWrap: 'wrap' }}>
            <input type="color" value={color} onChange={e => setColor(e.target.value)}
              style={{ width: 48, height: 36, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, cursor: 'pointer' }} />
            <input type="text" value={color} onChange={e => setColor(e.target.value)} maxLength={7}
              style={{ width: 90, padding: '6px 8px', border: `1px solid ${COLORS.line}`,
                borderRadius: RADIUS.sm, fontSize: TYPO.sizes.sm, fontFamily: TYPO.mono,
                background: COLORS.bg, color: COLORS.text, boxSizing: 'border-box' }} />
            <div style={{ display: 'flex', gap: 4 }}>
              {PARTY_COLORS_PRESET.map(c => (
                <button key={c} type="button" onClick={() => setColor(c)}
                  style={{ width: 22, height: 22, background: c, border: color === c ? '2px solid #000' : '1px solid #ccc',
                    borderRadius: 4, cursor: 'pointer', padding: 0 }}
                  title={c} />
              ))}
            </div>
          </div>
        </div>
        <div>
          <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 4, fontWeight: TYPO.weights.semibold, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Poznámka</div>
          <textarea value={notes} onChange={e => setNotes(e.target.value)} rows={2}
            style={{ width: '100%', padding: '8px 10px', border: `1px solid ${COLORS.line}`,
              borderRadius: RADIUS.sm, fontSize: TYPO.sizes.sm, resize: 'vertical',
              background: COLORS.bg, color: COLORS.text, boxSizing: 'border-box' }} />
        </div>
        <div style={{ display: 'flex', gap: SPACE.sm, justifyContent: 'flex-end' }}>
          <BtnGhost onClick={onClose} disabled={busy}>Zrušiť</BtnGhost>
          <BtnAdd onClick={save} disabled={busy || !name.trim() || !!navrh.chyba}>{busy ? 'Ukladám…' : 'Vytvoriť partiu'}</BtnAdd>
        </div>
      </div>
    </Modal>
  )
}

// ── PARTNERI_TAB_v1 — Spriaznení SZČO partneri (ústava 11.6b) ─────────
const VZTAH_LABELS = {
  self_szco: 'Vlastné SZČO',
  manzelka:  'Manželka SZČO',
  rodinny:   'Rodinný SZČO',
  iny:       'Iný',
}

function PartneriView({ employeeId, employee }) {
  const [partneri, setPartneri] = useState([])
  const [customers, setCustomers] = useState([])
  const [pridanie, setPridanie] = useState(false)
  const [novyPartnerId, setNovyPartnerId] = useState('')
  const [novyVztah, setNovyVztah] = useState('rodinny')
  const [novaPoznamka, setNovaPoznamka] = useState('')
  const [busy, setBusy] = useState(false)
  const toast = useToast()

  function nacitaj() {
    fetchAuth(`/api/employees/${employeeId}/partners`)
      .then(r => r.ok ? r.json() : [])
      .then(d => setPartneri(Array.isArray(d) ? d : []))
      .catch(() => {})
  }
  useEffect(() => {
    nacitaj()
    fetchAuth('/api/customers').then(r => r.ok ? r.json() : []).then(d => setCustomers(Array.isArray(d) ? d : (d.rows || []))).catch(() => {})
  }, [employeeId])

  async function pridaj() {
    if (!novyPartnerId) { toast.error('Vyber partnera'); return }
    setBusy(true)
    try {
      const r = await fetchAuth(`/api/employees/${employeeId}/partners`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ partner_id: novyPartnerId, vztah: novyVztah, poznamka: novaPoznamka }),
      })
      if (!r.ok) throw new Error('save failed')
      toast.success('Spriaznený partner pridaný')
      setPridanie(false); setNovyPartnerId(''); setNovyVztah('rodinny'); setNovaPoznamka('')
      nacitaj()
    } catch (e) { toast.error('Chyba pri pridávaní') } finally { setBusy(false) }
  }

  async function odpoji(partnerId) {
    if (!confirm('Naozaj odpojiť tohto SZČO partnera od zamestnanca?')) return
    try {
      const r = await fetchAuth(`/api/employees/${employeeId}/partners/${partnerId}`, { method: 'DELETE' })
      if (!r.ok) throw new Error('failed')
      toast.success('Odpojený')
      nacitaj()
    } catch (e) { toast.error('Chyba') }
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md, padding: SPACE.sm }}>
      <div style={{
        padding: SPACE.md, background: 'rgba(124,58,237,0.06)',
        border: `1px solid #7c3aed`, borderRadius: RADIUS.md,
        fontSize: TYPO.sizes.sm, color: COLORS.text,
      }}>
        <strong style={{ color: '#7c3aed' }}>Spriaznení SZČO partneri</strong> — SZČO ktorí fakturujú za prácu tohto zamestnanca
        (vlastné SZČO / manželka / rodinný). Cash FA pre nich = <strong>bez limitu €400</strong> (ústava 12.3 výnimka — ide o jeho mzdu).
      </div>

      {partneri.length === 0 ? (
        <div style={{ padding: SPACE.lg, color: COLORS.muted, textAlign: 'center',
          background: COLORS.bgSoft, borderRadius: RADIUS.md, fontSize: TYPO.sizes.sm }}>
          Žiadny spriaznený SZČO partner.
        </div>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: TYPO.sizes.sm }}>
          <thead>
            <tr style={{ borderBottom: `2px solid ${COLORS.line}` }}>
              <th title="Ako k sebe človek a tá SZČO patria — Vlastné SZČO, Manželka SZČO, Rodinný SZČO alebo Iný. Vzťah zapisuje človek, Matrix si ho nikdy nedomýšľa." style={tdh}>Vzťah</th>
              <th title="Karta z Partnerov, ktorá za prácu tohto človeka fakturuje. Partner sa zakladá v Partneroch, tu sa iba pripojí." style={tdh}>Partner (SZČO)</th>
              <th title="IČO tej SZČO z karty partnera. Podľa neho sa k osobe priraďujú došlé faktúry vrátane importovaných, ktoré nemajú vyplneného partnera." style={tdh}>IČO</th>
              <th title="Krátke vysvetlenie, prečo je väzba zapísaná (napríklad že fakturuje za omietkárske práce). Nie je to poznámka k zamestnancovi — tá je v Detaile." style={tdh}>Poznámka</th>
              <th style={tdh} />
            </tr>
          </thead>
          <tbody>
            {partneri.map(p => (
              <tr key={p.partner_id} style={{ borderBottom: `1px solid ${COLORS.lineSoft}` }}>
                <td style={tdc}>{VZTAH_LABELS[p.vztah] || p.vztah}</td>
                <td style={tdc}><strong>{p.partner_name || '(bez mena)'}</strong> <span style={{ color: COLORS.muted, fontSize: TYPO.sizes.xs }}>({p.partner_id})</span></td>
                <td style={{ ...tdc, fontFamily: TYPO.mono, fontSize: TYPO.sizes.xs }}>{p.partner_ico || '—'}</td>
                <td style={{ ...tdc, color: COLORS.muted, fontSize: TYPO.sizes.xs }}>{p.poznamka || '—'}</td>
                <td style={{ ...tdc, textAlign: 'right' }}>
                  <button onClick={() => odpoji(p.partner_id)}
                    style={{ background: 'transparent', border: 'none', cursor: 'pointer',
                      color: COLORS.remove, fontSize: TYPO.sizes.sm, padding: '2px 6px' }}
                    title="Odpojiť">✕</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {!pridanie ? (
        <BtnAdd onClick={() => setPridanie(true)} size="sm">+ Pridať spriazneného partnera</BtnAdd>
      ) : (
        <div style={{
          padding: SPACE.md, background: COLORS.bgSoft,
          border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md,
          display: 'flex', flexDirection: 'column', gap: SPACE.sm,
        }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: SPACE.sm }}>
            <Field label="Partner (SZČO) *">
              <SearchableSelect value={novyPartnerId} onChange={setNovyPartnerId}
                options={customers
                  .filter(c => (c.partner_type === 'dodavatel' || c.partner_type === 'oboje' || c.linked_employee_id) && !partneri.some(p => p.partner_id === c.id))
                  .map(c => ({ value: c.id, label: c.name + (c.ico ? ` · IČO ${c.ico}` : '') }))}
                placeholder="Vyber SZČO partnera…" />
            </Field>
            <Field label="Vzťah *">
              <SearchableSelect value={novyVztah} onChange={setNovyVztah}
                options={Object.entries(VZTAH_LABELS).map(([k, v]) => ({ value: k, label: v }))} />
            </Field>
          </div>
          <Field label="Poznámka">
            <input type="text" value={novaPoznamka} onChange={e => setNovaPoznamka(e.target.value)}
              placeholder="napr. manželka, faktúruje za omietkárske práce"
              style={inputStyle} />
          </Field>
          <div style={{ display: 'flex', gap: SPACE.sm, justifyContent: 'flex-end' }}>
            <BtnGhost onClick={() => setPridanie(false)} size="sm">Zrušiť</BtnGhost>
            <BtnAdd onClick={pridaj} disabled={busy} size="sm">{busy ? 'Ukladám…' : 'Pridať'}</BtnAdd>
          </div>
        </div>
      )}
    </div>
  )
}

// ── FinancnyPrehlad — mzdy + zálohy + FA cez spriaznených ─────────────
function FinancnyPrehlad({ employeeId }) {
  const [data, setData] = useState(null)
  const [rok, setRok] = useState(new Date().getFullYear())
  useEffect(() => {
    fetchAuth(`/api/employees/${employeeId}/financial-summary?year=${rok}`)
      .then(r => r.ok ? r.json() : null)
      .then(setData)
      .catch(() => {})
  }, [employeeId, rok])
  if (!data) return <div style={{ padding: SPACE.md, color: COLORS.muted }}>Načítavam…</div>
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md, padding: SPACE.sm }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: SPACE.xs }}>
        <button onClick={() => setRok(y => y - 1)} style={{ padding: '4px 10px', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, background: COLORS.bg, cursor: 'pointer', fontFamily: 'inherit' }}>‹</button>
        <strong style={{ minWidth: 50, textAlign: 'center', fontFamily: TYPO.mono }}>{rok}</strong>
        <button onClick={() => setRok(y => y + 1)} style={{ padding: '4px 10px', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, background: COLORS.bg, cursor: 'pointer', fontFamily: 'inherit' }}>›</button>
        <div style={{ flex: 1 }} />
        {data.tok && !data.tok.skryte && <strong title="Najmenej toľko peňazí, koľko podľa Matrixu odišlo človeku a jeho rodine (výplaty v Mzdách 2026, starý zošit 26-MZDY, uhradené faktúry spriaznených firiem) — každé euro najviac raz, nárok sa nepripočítava" style={{ fontSize: TYPO.sizes.lg, color: COLORS.total }}>
          SPOLU TOK (vyplatené): {SK.eur(data.tok.spolu)}
        </strong>}{/* MZDY_KARTA_TOK_V1 */}
      </div>

      {/* MZDY */}
      <div style={{ padding: SPACE.md, background: COLORS.bgSoft, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md }}>
        <div style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.bold, color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: SPACE.sm }}>
          Mzdy {rok}
        </div>
        {/* MZDY_KARTA_ZOSIT_V1: zošit Mzdy 2026 + archív do 30. 6. (ten istý výpočet ako záložka Mzdy na zákazke); vyplatené a čaká len zo zošita */}
        {(!data.mzdy || data.mzdy.skryte) ? (
          <div style={{ fontSize: TYPO.sizes.sm, color: COLORS.muted, fontStyle: 'italic' }}>Mzdy vidí vedenie, office a back office (Mzdy 2026).</div>
        ) : (<>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: SPACE.sm, fontSize: TYPO.sizes.sm }}>
          {/* MZDY_KARTA_TOK_V1: tie isté čísla a slová ako kniha partie v Mzdách 2026 (Nárok · Vyplatené · Dlhujeme im / Oni nám) */}
          <Mini label="Nárok (Mzdy 2026)" value={SK.eur((data.mzdy.zosit && data.mzdy.zosit.narok) || 0)} color={COLORS.nav} />
          <Mini label="Vyplatené (Mzdy 2026)" value={SK.eur(data.mzdy.zaplatene)} color={COLORS.add} />
          {data.mzdy.preplatok > 0
            ? <Mini label="Oni nám (Mzdy 2026)" value={SK.eur(data.mzdy.preplatok)} color={COLORS.nav} highlight />
            : <Mini label="Dlhujeme im (Mzdy 2026)" value={SK.eur(data.mzdy.caka)} color={COLORS.remove} highlight />}
          <Mini label="Nárok v archíve do 30. 6." value={SK.eur((data.mzdy.archiv && data.mzdy.archiv.suma) || 0)} color={COLORS.muted} />
        </div>
        <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: SPACE.sm, lineHeight: 1.6 }}>
          {data.mzdy.zosit && <div>Mzdy 2026, rok {rok}: nárok {SK.eur(data.mzdy.zosit.narok)} · vyplatené {SK.eur(data.mzdy.zosit.vyplatene)}{data.mzdy.zosit.caka_na_pokladnu > 0 ? ' · z toho hotovosť ' + SK.eur(data.mzdy.zosit.caka_na_pokladnu) + ' ešte nie je spárovaná s Pokladňou alebo ATM (ráta sa do Dlhujeme im)' : ''}{data.mzdy.zosit.zadrzane > 0 ? ' · zadržané ' + SK.eur(data.mzdy.zosit.zadrzane) : ''} · {data.mzdy.pocet} pohybov</div>}
          {data.mzdy.archiv && (data.mzdy.archiv.suma > 0 || data.mzdy.archiv.vylucene > 0) && <div>Archív do 30. 6. 2026 je len prehľad — stav výplat sa z neho neberie{data.mzdy.archiv.vylucene > 0 ? '; ' + SK.eur(data.mzdy.archiv.vylucene) + ' za mesiace, ktoré sú už v Mzdách 2026, sa neráta druhýkrát' : ''}.</div>}
          {data.mzdy.partia && data.mzdy.aktivny && <div>
            {data.mzdy.partia.predak_id && data.mzdy.partia.predak_id !== employeeId ? 'Člen partie — nárok a výplaty sa v Mzdách 2026 zapisujú na parťáka ' + data.mzdy.partia.predak + '. ' : ''}
            Zostatok partie dnes (všetky roky) — <a href={'/v2/mzdy2026?partia=' + data.mzdy.partia.id} style={{ color: COLORS.nav }}>{data.mzdy.partia.nazov}</a>: {data.mzdy.partia.oni_nam > 0 ? 'preplatok ' + SK.eur(data.mzdy.partia.oni_nam) : 'dlhujeme partii ' + SK.eur(data.mzdy.partia.dlhujeme_im)}
          </div>}
        </div>
        </>)}
      </div>

      {/* MZDY_KARTA_TOK_V1: SPOLU TOK — len vyplatené peniaze, každé euro raz (11.6b) */}
      {data.tok && !data.tok.skryte && (
      <div style={{ padding: SPACE.md, background: COLORS.bgSoft, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md }}>
        <div style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.bold, color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: SPACE.sm }}>
          Spolu tok {rok} — vyplatené peniaze, každé euro raz
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: SPACE.sm, fontSize: TYPO.sizes.sm }}>
          <Mini label="Spolu tok" value={SK.eur(data.tok.spolu)} color={COLORS.total} highlight />
          <Mini label="Výplaty v Mzdách 2026" value={SK.eur(data.tok.mzdy2026)} color={COLORS.add} />
          <Mini label="Do 5. 7. (starý zošit / FA)" value={SK.eur(data.tok.do_obdobie)} color={COLORS.add} />
          <Mini label="Faktúry spriaznených po 5. 7." value={SK.eur(data.tok.fa_po)} color="#7c3aed" />
        </div>
        <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: SPACE.sm, lineHeight: 1.6 }}>
          <div>Najmenej toľko odišlo podľa Matrixu (aj cez rodinnú firmu); nárok sa do toku nepripočítava. Výplaty zapísané len v Google Sheete 26-MZDY po 5. 7. Matrix nepozná.</div>
          {(data.tok.stara_evidencia > 0 || data.tok.fa_do > 0) && <div>Do 5. 7. (nahratie starého zošita 26-MZDY): zošit vedie vyplatené {SK.eur(data.tok.stara_evidencia)}, uhradené faktúry spriaznených {SK.eur(data.tok.fa_do)}{data.tok.mzdy2026_fa_do > 0 ? ' (z toho ' + SK.eur(data.tok.mzdy2026_fa_do) + ' priradené ako výplata v Mzdách 2026)' : ''}. Zošit zapisoval aj výplaty faktúrou, ale nie vždy — do toku ide väčšie z čísel, aby sa nič nerátalo dvakrát{data.tok.prekryv > 0 ? '; ak zošit niektoré faktúry nezapísal, vyplatené mohlo byť až o ' + SK.eur(data.tok.prekryv) + ' viac' : ''}.</div>}
          {data.tok.fa_po > 0 && <div>Faktúry spriaznených uhradené po 5. 7. ({SK.eur(data.tok.fa_po)}) nie sú priradené ako výplata v Mzdách 2026 — „Dlhujeme im“ ich neodpočítava; ak sú to výplaty mzdy, priraďte ich v Mzdách 2026.</div>}
          {data.tok.fa_v_zosite > 0 && <div>Faktúry spriaznených {SK.eur(data.tok.fa_v_zosite)} sú priradené ako výplata v Mzdách 2026 — uhradené sú v toku tam (uhradené do 5. 7. v období do 5. 7.), neuhradené nie.</div>}
          {(data.tok.fa_neuhradene > 0 || data.tok.fa_subdodavka > 0 || data.tok.mzdy2026_fa_neuhradene > 0) && <div>
            Mimo toku: {[(data.tok.fa_neuhradene + (data.tok.mzdy2026_fa_neuhradene || 0)) > 0 ? SK.eur(data.tok.fa_neuhradene + (data.tok.mzdy2026_fa_neuhradene || 0)) + ' faktúr ešte neuhradených' : '', data.tok.fa_subdodavka > 0 ? SK.eur(data.tok.fa_subdodavka) + ' subdodávka (nie mzda)' : ''].filter(Boolean).join(' · ')}.
          </div>}
        </div>
      </div>)}

      {/* ZÁLOHY — stará evidencia 26-MZDY (MZDY_KARTA_TOK_V1) */}
      {!(data.zalohy && data.zalohy.skryte) && (
      <div style={{ padding: SPACE.md, background: COLORS.bgSoft, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md }}>
        <div style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.bold, color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: SPACE.sm }}>
          Vyplatené podľa starého zošita 26-MZDY {rok}
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: SPACE.sm, fontSize: TYPO.sizes.sm }}>
          <Mini label="Vyplatené" value={SK.eur(data.zalohy.suma)} color={COLORS.total} highlight />
          <Mini label="Pohybov" value={String(data.zalohy.pocet || 0)} color={COLORS.muted} />
        </div>
        <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: SPACE.sm, lineHeight: 1.6 }}>
          {(data.zalohy.pocet > 0 || data.zalohy.zapocitane) ? <div>Zálohy {SK.eur(data.zalohy.zalohy || 0)}{data.zalohy.zapocitane ? ' · započítané so mzdou ' + SK.eur(Math.abs(data.zalohy.zapocitane)) + ' (odpočíta sa)' : ''}{data.zalohy.mzdy_zaplatene ? ' · mzdy označené zaplatené ' + SK.eur(data.zalohy.mzdy_zaplatene) : ''} — spolu to, čo zošit 26-MZDY vedie ako vyplatené (nárok v archíve mínus jeho zostatok).</div> : <div>V starom zošite 26-MZDY nemá zapísanú výplatu.</div>}
          {data.mzdy && data.mzdy.partia && data.zalohy.zalohy_pocet > 0 && <div>Zošit 26-MZDY viedol zálohy partie spravidla na jedného človeka — suma môže obsahovať aj výplaty iných členov partie {data.mzdy.partia.nazov} a ich faktúry môžu byť aj na ich kartách.</div>}
        </div>
      </div>)}

      {/* FA SPRIAZNENÝCH */}
      <div style={{ padding: SPACE.md, background: 'rgba(124,58,237,0.06)', border: `1px solid #7c3aed`, borderRadius: RADIUS.md }}>
        <div style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.bold, color: '#7c3aed', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: SPACE.sm }}>
          FA cez spriaznených SZČO partnerov {rok}
        </div>
        {data.fa_partneri.partneri.length === 0 ? (
          <div style={{ fontSize: TYPO.sizes.sm, color: COLORS.muted, fontStyle: 'italic' }}>
            Žiadny spriaznený SZČO partner — pridaj ho v tabe „SZČO partneri".
          </div>
        ) : (
          <>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: SPACE.sm, fontSize: TYPO.sizes.sm, marginBottom: SPACE.sm }}>
              <Mini label="Suma celkom" value={data.fa_partneri.skryte ? '—' : SK.eur(data.fa_partneri.suma)} color="#7c3aed" highlight />
              <Mini label="Čaká úhrada" value={data.fa_partneri.skryte ? '—' : SK.eur(data.fa_partneri.caka)} color={COLORS.remove} />
              <Mini label="FA pohybov" value={data.fa_partneri.skryte ? '—' : String(data.fa_partneri.pocet)} color={COLORS.muted} />
            </div>{/* MZDY_KARTA_TOK_V1: sumy FA spriaznených vidia len roly Miezd 2026 */}
            <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>
              Spriaznení partneri: {data.fa_partneri.partneri.map(p => `${p.name} (${VZTAH_LABELS[p.vztah] || p.vztah})`).join(' · ')}
            </div>
          </>
        )}
      </div>
    </div>
  )
}

function Mini({ label, value, color, highlight }) {
  return (
    <div style={{
      padding: SPACE.sm,
      background: highlight ? `${color}10` : COLORS.bg,
      border: `1px solid ${color}`,
      borderLeft: `3px solid ${color}`,
      borderRadius: RADIUS.sm,
    }}>
      <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '0.04em' }}>{label}</div>
      <div style={{ fontSize: TYPO.sizes.md, fontFamily: TYPO.mono, fontWeight: TYPO.weights.bold, color, marginTop: 2 }}>{value}</div>
    </div>
  )
}

const tdh = { padding: '6px 8px', textAlign: 'left', color: COLORS.muted, fontWeight: TYPO.weights.semibold, fontSize: TYPO.sizes.xs, textTransform: 'uppercase', letterSpacing: '0.06em' }
const tdc = { padding: '6px 8px' }


// ── MergeDialog (ústava 12.0 bod 1a — systémový duplikát) ──────────────
function MergeDialog({ employee, onClose, onDone }) {
  const [zamestnanci, setZamestnanci] = useState([])
  const [dstId, setDstId] = useState('')
  const [busy, setBusy] = useState(false)
  const [potvrdene, setPotvrdene] = useState(false)
  const toast = useToast()
  useEffect(() => {
    fetchAuth('/api/employees').then(r => r.ok ? r.json() : [])
      .then(d => setZamestnanci((Array.isArray(d) ? d : (d.rows || [])).filter(e => e.id !== employee.id)))
      .catch(() => {})
  }, [employee.id])
  const dstEmp = zamestnanci.find(e => e.id === dstId)
  async function zlucit() {
    if (!dstId) { toast.error('Vyber cieľového zamestnanca'); return }
    setBusy(true)
    try {
      const r = await fetchAuth(`/api/employees/${employee.id}/merge-to/${dstId}`, { method: 'POST' })
      const d = await r.json()
      if (!r.ok) throw new Error(d.error || 'merge failed')
      toast.success(`Spojené: ${d.src_name} → ${d.dst_name}${d.action === 'hard_deleted' ? ' (natrvalo vymazané)' : ''}`)
      if (onDone) onDone()
    } catch (e) { toast.error('Chyba: ' + e.message) } finally { setBusy(false) }
  }
  return (
    <Modal open={true} title={`Zlúčiť duplikát — ${employee.name}`} onClose={onClose} width={560}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
        <div style={{
          padding: SPACE.md, background: 'rgba(245,158,11,0.08)',
          border: `1px solid ${COLORS.total}`, borderRadius: RADIUS.md,
        }}>
          <div style={{ fontWeight: TYPO.weights.bold, color: COLORS.total, marginBottom: 4 }}>
            Zlučovanie duplikátu
          </div>
          <div style={{ fontSize: TYPO.sizes.sm, lineHeight: 1.5 }}>
            Tento záznam <strong>{employee.name}</strong> (ID {employee.id}) sa <strong>spojí s cieľovým záznamom</strong>.
            Všetky súvisiace dáta (mzdy, zálohy, dochádzka v Rozpise prác, sadzby, pridelené vozidlá,
            požičané náradie, spriaznení SZČO partneri) sa <strong>prenesú na cieľ</strong>.
            <br /><br />
            Ak po prenose <strong>nezostanú žiadne dáta naviazané</strong> na tento záznam,
            <strong> natrvalo sa vymaže</strong> z databázy. Operácia sa zapíše do auditu (kto, kedy, čo).
            <br />
            <span style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, fontStyle: 'italic' }}>
              Ústava 12.0 bod 1a — výnimka pre systémové duplikáty.
            </span>
          </div>
        </div>
        <Field label="Cieľový zamestnanec (kam zlúčiť) *">
          <SearchableSelect value={dstId} onChange={setDstId}
            options={zamestnanci.map(e => ({
              value: e.id,
              label: (e.name || `${e.firstName || ''} ${e.lastName || ''}`.trim()) + (e.ico ? ` · IČO ${e.ico}` : '') + ` (${e.id})`
            }))}
            placeholder="Vyber zamestnanca s rovnakou identitou…" />
        </Field>
        {dstEmp && (
          <div style={{
            padding: SPACE.sm, background: COLORS.bgSoft,
            border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm,
            fontSize: TYPO.sizes.sm,
          }}>
            <strong>Cieľ:</strong> {dstEmp.name || `${dstEmp.firstName || ''} ${dstEmp.lastName || ''}`.trim()} (ID {dstEmp.id})
            {dstEmp.ico && <><br /><strong>IČO:</strong> {dstEmp.ico}</>}
            {employee.ico === dstEmp.ico && (
              <div style={{ marginTop: 4, color: COLORS.add, fontWeight: TYPO.weights.semibold }}>
                ✓ IČO sedí — pravdepodobne reálny duplikát
              </div>
            )}
            {employee.ico !== dstEmp.ico && employee.ico && dstEmp.ico && (
              <div style={{ marginTop: 4, color: COLORS.remove, fontWeight: TYPO.weights.semibold }}>
                IČO sa nezhoduje — overiť!
              </div>
            )}
          </div>
        )}
        <label style={{ display: 'flex', alignItems: 'center', gap: SPACE.sm, padding: SPACE.sm,
          border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, cursor: 'pointer' }}>
          <input type="checkbox" checked={potvrdene} onChange={e => setPotvrdene(e.target.checked)} />
          <span style={{ fontSize: TYPO.sizes.sm }}>
            Potvrdzujem že <strong>{employee.name}</strong> je systémový duplikát a všetky dáta sa korektne presunú.
          </span>
        </label>
        <div style={{ display: 'flex', gap: SPACE.sm, justifyContent: 'flex-end' }}>
          <BtnGhost onClick={onClose} disabled={busy}>Zrušiť</BtnGhost>
          <Btn variant="remove" onClick={zlucit} disabled={busy || !dstId || !potvrdene}>
            {busy ? 'Zlučujem…' : 'Spojiť a natrvalo vymazať'}
          </Btn>
        </div>
      </div>
    </Modal>
  )
}


// ══════════════════════════════════════════════════════════════════
// RECORD MODAL — edit / new cez useRecordEditor (S1)
// Lock + dirty + Form→Confirm + DIFF — všetko zabudované v hooku.
// ══════════════════════════════════════════════════════════════════
// ZAMESTNANEC_ADRESA_V1: jednoriadková adresa → bunky — PARTNER_ADRESA_V1: adresaRozloz zo spoločného lib/adresa.js (vlastná kópia preč, 0.J)
const ROLY_OSOBNA_ZLOZKA = ['admin', 'owner', 'owner_view', 'office_manager', 'accountant']   // ZAMESTNANEC_ADRESA_V1: kto vidí a mení rodné číslo

function RecordModal({ open, record, user, onClose, onSaved }) {
  const [opts, setOpts] = useState({
    categories: [], parties: [], roles: [],
    uvazky: ['TPP','DPP','DoVP','DoBP','SZČO','Externe'],
    payTypes: ['hodinová','úkolová','mesačná'],
  })
  const [partyList, setPartyList] = useState([])    // /api/parties — pre FK dropdown
  const [groupList, setGroupList] = useState([])    // /api/schedule-groups — pre Skupina
  const [showNewParty, setShowNewParty] = useState(false)
  const [lookingUp, setLookingUp] = useState(false)
  const toastModal = useToast()
  const [szcoNavrh, setSzcoNavrh] = useState([])   // SZCO_PREPOJ_V1: partner s IČO, ktorý je asi táto osoba
  const [nepripom, setNepripom] = useState(false)   // ZAMESTNANCI_OCHRANA_V1: pripomínanie narodenín vypína len Mirko
  useEffect(() => { setNepripom(!!record?.narodeniny_nepripominat) }, [record?.id, record?.narodeniny_nepripominat])
  async function lookupIcoZam(edRef) {
    const ico = (edRef.values.ico || '').trim()
    if (!ico) { toastModal.warn ? toastModal.warn('Zadaj IČO pred vyhľadaním') : toastModal.show('Zadaj IČO', 'error'); return }
    // Poľské NIP = 10 číslic (často s prefixom PL alebo bez)
    // Slovenské IČO = 8 číslic
    const cisla = ico.replace(/\D/g, '')
    if (cisla.length === 10 || ico.toUpperCase().startsWith('PL')) {
      toastModal.show('Poľské NIP — ORSR nepodporuje. Použi VIES (zatiaľ ručne) alebo PL Główny Urząd Statystyczny.', 'warn')
      return
    }
    if (cisla.length !== 8) {
      toastModal.show('Neštandardný formát IČO (očakávané 8 číslic SR). Pre EU dodávateľov ručne.', 'warn')
      return
    }
    setLookingUp(true)
    try {
      const r = await fetchAuth(`/api/ico/lookup?ico=${encodeURIComponent(ico)}`)
      const j = await r.json()
      if (!r.ok || j.error || j.ok === false) {
        toastModal.show(`ORSR: ${j.error || j.message || `HTTP ${r.status}`}`, 'error')
        return
      }
      const d = j.data || j
      if (!d || !d.name) { toastModal.show('ORSR neviem identifikovať', 'error'); return }
      // Guard (Barlik/BASTAV 7.7.): register musí vrátiť TO ISTÉ IČO — inak nič nevypĺňať
      const dIco = String(d.ico || '').replace(/\D/g, '')
      if (dIco !== cisla) { toastModal.show('Register vrátil iné IČO (' + (d.ico || '—') + ') než hľadané ' + cisla + ' — nič nevypĺňam, skús znova alebo doplň ručne.', 'error'); return }
      // SZČO mená — typicky „Meno Priezvisko" (alebo Priezvisko Meno) → split
      const fullName = d.name.trim()
      const jeFirma = /(s\. ?r\. ?o|a\. ?s\.|k\. ?s\.|v\. ?o\. ?s|družstvo|spol\.)/i.test(fullName)
      let firstName = edRef.values.firstName
      let lastName = edRef.values.lastName
      if (!firstName && !lastName && !jeFirma) {
        const parts = fullName.split(/\s+/)
        if (parts.length >= 2) {
          // ORSR uvádza zvyčajne „Priezvisko Meno", ale SZČO býva opačne
          // Bezpečnejšie: prvé slovo = meno, zvyšok = priezvisko
          firstName = parts[0]
          lastName = parts.slice(1).join(' ')
        } else {
          firstName = fullName
        }
      }
      if (jeSubdodavka(edRef.values)) {
        // p32 subdodávka: firma, sídlo, IČ DPH a DIČ z registra; názov v Rozpise = firma, ak nie je vyplnené meno
        edRef.set('firma', fullName)
        if (d.address && !edRef.values.adresa_ulica && !edRef.values.adresa_obec) edRef.setValues(adresaZRegistra(d))   // ZAMESTNANEC_ADRESA_V1; PARTNER_ADRESA_V1: sídlo z registra po bunkách
        if (d.ic_dph && !edRef.values.ic_dph) edRef.set('ic_dph', d.ic_dph)
        if (d.dic && !edRef.values.dic) edRef.set('dic', d.dic)
        if (!edRef.values.firstName && !edRef.values.lastName) {
          if (jeFirma) edRef.set('firstName', fullName)
          else { edRef.set('firstName', firstName); edRef.set('lastName', lastName) }
        }
      } else if (jeFirma) {
        toastModal.show('IČO patrí firme „' + fullName + '" — meno osoby vyplň ručne (firma sa naviaže ako SZČO dodávateľ).', 'warn')
      } else {
        edRef.set('firstName', firstName)
        edRef.set('lastName', lastName)
      }
      edRef.set('ico', cisla)
      // Aj employee_type = szco ak je IČO
      if (d.ico && !['szco', TYP_SUBDODAVKA].includes(edRef.values.employee_type)) edRef.set('employee_type', 'szco')
      toastModal.show(`Načítané z ORSR: ${fullName}`, 'success')
    } catch (e) {
      toastModal.show(`Lookup zlyhal: ${e.message}`, 'error')
    } finally {
      setLookingUp(false)
    }
  }
  function loadParties() {
    fetchAuth('/api/parties').then(r => r.ok ? r.json() : []).then(d => setPartyList(Array.isArray(d) ? d : [])).catch(() => {})
  }
  function loadGroups() {
    fetchAuth('/api/schedule-groups').then(r => r.ok ? r.json() : []).then(d => setGroupList(Array.isArray(d) ? d : [])).catch(() => {})
  }
  useEffect(() => {
    if (!open) return
    fetchAuth('/api/employees/options')
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d) setOpts(o => ({ ...o, ...d })) })
      .catch(() => {})
    loadParties()
    loadGroups()
  }, [open])
  const toOpts = (arr) => (arr || []).map(v => ({ value: v, label: v }))
  const isNew = !record

  const pinGateOsoba = usePinGate()   // identita_v1: vedomá druhá karta len so schválením PIN-om (63)
  const ed = useRecordEditor({
    resource: CFG.resource,
    id: record?.id || null,
    user,
    initial: {
      firstName:     record?.firstName     || '',
      lastName:      record?.lastName      || '',
      birth_date:    record?.birth_date    || '',
      // Uradne tlaciva (Mirko 29.7.): potvrdenie o cinnostiach vodica + splnomocnenie na vozidlo
      // si tieto udaje tahaju z karty — nesmu sa prepisovat rucne pri kazdom dokumente.
      doklad_cislo:  record?.doklad_cislo  || '',
      datum_nastupu: record?.datum_nastupu || '',
      adresa:        record?.adresa        || '',
      ...((r) => { const q = (r && (r.adresa_ulica || r.adresa_obec)) ? r : adresaRozloz(r && r.adresa); return { adresa_ulica: q.adresa_ulica || '', adresa_cislo: q.adresa_cislo || '', adresa_psc: q.adresa_psc || '', adresa_obec: q.adresa_obec || '', adresa_stat: q.adresa_stat || 'SK' } })(record),   // ZAMESTNANEC_ADRESA_V1
      ...(ROLY_OSOBNA_ZLOZKA.includes(user?.role) ? { rodne_cislo: record?.rodne_cislo || '' } : {}),   // ZAMESTNANEC_ADRESA_V1: inak sa RČ vôbec neposiela
      is_partak:     !!record?.is_partak,
      sofer_zastup:  !!record?.sofer_zastup,
      manual_payroll: !!record?.manual_payroll,
      attendance_required: !!record?.attendance_required,   // dochadzka_v1
      category:      record?.category      || '',
      role:          record?.role          || '',
      party:         record?.party         || 'P1',
      payType:       record?.payType       || 'hodinová',
      rate:          record?.rate          != null ? String(record.rate) : '',
      milestone_m2:  record?.milestone_m2  != null ? String(record.milestone_m2) : '',
      phone:         record?.phone         || '',
      email:         record?.email         || '',
      titul:         record?.titul         || '',
      funkcia:       record?.funkcia       || '',
      uvazok:        record?.uvazok        || 'TPP',
      nationality:   record?.nationality   || 'SK',
      employee_type: record?.employee_type || 'employee',
      ico:           record?.ico           || '',
      firma:         record?.partner_nazov  || '',   // p32 subdodávka — údaje partnera (uložia sa k partnerovi)
      ic_dph:        record?.partner_ic_dph || '',
      dic:           record?.partner_dic    || '',
      notes:         record?.notes         || '',
      rates:         Array.isArray(record?.rates) ? record.rates : [],
    },
    fields: EDIT_FIELDS,
    onSubmit: async (values) => {
      const r = await fetchAuth(
        isNew ? CFG.apiBase : `${CFG.apiBase}/${record.id}`,
        { method: isNew ? 'POST' : 'PUT', body: JSON.stringify(values) }
      )
      if (r.ok) {
        try {
          const data = await r.clone().json()
          if (data?.szco_link) {
            const act = data.szco_link.action
            const msg = act === 'created'
              ? `SZČO ${data.szco_link.customer_name} vytvorený aj v Partneroch (ID ${data.szco_link.customer_id})`
              : `SZČO linknutý s existujúcim partnerom ${data.szco_link.customer_name} (ID ${data.szco_link.customer_id})`
            try { window.dispatchEvent(new CustomEvent('kamir-toast', { detail: { typ: 'success', text: msg } })) } catch (_) { console.log(msg) }   // toast tu nie je v scope (30.7.)
          }
        } catch (_) {}
      }
      if (!r.ok) {
        const d = await r.json().catch(() => ({}))
        if (d.pin_potrebny && d.akcia === 'citlive_udaje_zamestnanca') {   // ZAMESTNANCI_OCHRANA_V1
          const gate = await pinGateOsoba('citlive_udaje_zamestnanca', { osoba: ((values.firstName || '') + ' ' + (values.lastName || '')).trim(), polia: (d.polia || []).join(', ') })
          if (!gate || !gate.ok) throw new Error('Zrušené — citlivé údaje zamestnanca sa bez PIN-u nemenia.')
          const r2 = await fetchAuth(isNew ? CFG.apiBase : `${CFG.apiBase}/${record.id}`, { method: isNew ? 'POST' : 'PUT', headers: { 'X-Pin-Audit-Id': String(gate.audit_id || '') }, body: JSON.stringify(values) })
          if (r2.ok) return
          const d2 = await r2.json().catch(() => ({}))
          throw new Error(d2.error || 'Uloženie zlyhalo.')
        }
        // dedup (ústava sek. 13) — backend vracia 409 pri duplicite
        // identita_v1 (Mirko 18. 10. 2026; ústava 136.1, 139, 63): server našiel tú istú osobu (meno bez diakritiky, telefón, e-mail).
        // Predvolene sa druhá karta nezakladá — človek otvorí existujúcu (odkaz, 139). Vedomá druhá karta len so schválením PIN-om.
        if (r.status === 409 && (d.error === 'DUPLICATE_PERSON' || d.error === 'DUPLICATE_NAME')) {
          const sprava = d.message || 'Táto osoba už v Matrixe je.'
          if (window.confirm(sprava + '\n\nOK = otvoriť existujúcu kartu ' + (d.existingName || d.existingId || '') + '\nZrušiť = založiť napriek tomu druhú kartu (schváli Mirko PIN-om)')) {
            try { window.location.assign('/v2' + (d.odkaz || ('/zamestnanci?open=' + d.existingId))) } catch (_) {}
            throw new Error('Otváram existujúcu kartu ' + (d.existingName || d.existingId) + '.')
          }
          const gate = await pinGateOsoba('duplicita_osoby', { osoba: ((values.firstName || '') + ' ' + (values.lastName || '')).trim(), existujuca: d.existingId || '' })
          if (!gate || !gate.ok) throw new Error('Zrušené — bez PIN-u sa druhá karta nezakladá.')
          const r2 = await fetchAuth(CFG.apiBase, { method: 'POST', headers: { 'X-Pin-Audit-Id': String(gate.audit_id || '') }, body: JSON.stringify({ ...values, allow_duplicate: true }) })
          if (r2.ok) return
          const d2 = await r2.json().catch(() => ({}))
          throw new Error(d2.message || d2.error || 'Uloženie zlyhalo.')
        }
        if (r.status === 409) throw new Error(d.message || 'Taký záznam už existuje.')
        throw new Error(d.error || 'Uloženie zlyhalo.')
      }
    },
  })

  if (!open) return null

  const doClose = () => ed.requestClose(onClose)
  // p40: subdodávka je parťák, ak partia nemá iného parťáka; v partii s parťákom je členom (parťák ostáva, mení sa len, kto fakturuje)
  const subInyPartak = jeSubdodavka(ed.values) ? inyPartakPartie(ed.values, partyList, record?.id) : null
  const subPartakPovinny = jeSubdodavka(ed.values) && !subInyPartak

  const validate = (v) => {
    if (jeSubdodavka(v)) { const ch = chybySubdodavky(v); return ch.length ? 'Subdodávka — chýba: ' + ch.join(', ') + '.' : null }   // p32
    if (!v.firstName || !v.firstName.trim()) return 'Meno je povinné.'
    if (!v.lastName || !v.lastName.trim()) return 'Priezvisko je povinné.'
    if (v.is_partak && !(v.category || '').trim()) return 'Parťák musí mať vybranú Skupinu — inak sa nezobrazí v Rozpise prác (ústava 3).'
    return null
  }

  const handleConfirm = async () => {
    const ok = await ed.submit()
    if (ok) onSaved()
  }

  const readOnly = !ed.canEdit

  // SZCO_PREPOJ_V1 (Mirko 26. 10. 2026: „ak už niekde je SZČO prečo tu nie je???“): Matrix nájde partnera s IČO pre túto osobu a ponúkne prepojenie
  useEffect(() => {
    setSzcoNavrh([])
    if (!open || !record?.id || (record.ico || '').trim()) return
    let zive = true
    fetchAuth(`${CFG.apiBase}/${record.id}/szco-navrh`).then(r => r.ok ? r.json() : { navrhy: [] }).then(j => { if (zive) setSzcoNavrh(Array.isArray(j.navrhy) ? j.navrhy : []) }).catch(() => {})
    return () => { zive = false }
  }, [open, record?.id])   // eslint-disable-line react-hooks/exhaustive-deps
  const prepojSzco = (n) => {
    ed.set('ico', n.ico)
    if (ed.values.employee_type !== TYP_SUBDODAVKA) { ed.set('employee_type', 'szco'); ed.set('uvazok', 'SZČO') }
    toastModal.show('Prepojené so SZČO ' + n.nazov + ' (IČO ' + n.ico + ') — ulož kartu', 'success')
  }

  return (
    <>
      <Modal
        open
        onClose={doClose}
        onDirtyClose={doClose}
        isDirty={ed.isDirty}
        title={isNew ? CFG.newLabel : `Upraviť — ${record.name || record.firstName}`}
        subtitle={ed.phase === 'confirm' ? 'Skontroluj zmeny pred uložením' : ''}
        maxWidth={980}   // ZAMESTNANCI_MOCKUP_V1: dvojstĺpcový formulár sa do 640 px nezmestil, pravý stĺpec bol orezaný
        footer={
          ed.phase === 'form' ? (
            <>
              <BtnGhost onClick={doClose}>Zrušiť</BtnGhost>
              <BtnAdd onClick={() => ed.goConfirm(validate)} disabled={readOnly}>
                Uložiť →
              </BtnAdd>
            </>
          ) : (
            <>
              <BtnGhost onClick={ed.back}>← Späť na úpravu</BtnGhost>
              <BtnAdd onClick={handleConfirm} disabled={ed.submitting}>
                {ed.submitting ? 'Ukladám…' : '✓ Potvrdiť uloženie'}
              </BtnAdd>
            </>
          )
        }
      >
        {/* LOCK banner — záznam upravuje niekto iný (ústava 53.7) */}
        {readOnly && ed.lockedBy && (
          <div style={{
            background: TINT.remove,
            border: `1px solid ${COLORS.remove}`,
            borderRadius: RADIUS.md,
            padding: SPACE.sm,
            marginBottom: SPACE.md,
            fontSize: TYPO.sizes.sm,
            color: COLORS.remove,
          }}>
            Záznam práve upravuje <strong>{ed.lockedBy}</strong>. Editácia je zamknutá.
          </div>
        )}

        {ed.error && (
          <div style={{
            background: TINT.remove,
            border: `1px solid ${COLORS.remove}`,
            borderRadius: RADIUS.md,
            padding: SPACE.sm,
            marginBottom: SPACE.md,
            fontSize: TYPO.sizes.sm,
            color: COLORS.remove,
          }}>{ed.error}</div>
        )}

        {ed.phase === 'form' ? (
          // ── FORM fáza ──────────────────────────────────────────────
          <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
            {/* ℹ️ LUXUSNÉ VYSVETLIVKY — čo je čo (partia) */}
            <div style={{ background: '#eef6ff', border: '1px solid #c7ddfb', borderRadius: RADIUS.md, padding: SPACE.md, fontSize: TYPO.sizes.xs, color: '#334155', lineHeight: 1.55 }}>
              <div style={{ fontWeight: TYPO.weights.bold, color: '#1d4ed8', marginBottom: 5 }}>Čo je čo — ako vytvoriť partiu</div>
              <div style={{ marginBottom: 2 }}><b>Parťák</b> = vedie partiu, píše denník na mobile, dostáva mzdový návrh z Podkladov. Nezávislé od remesla (aj maliar/poterár môže byť parťák).</div>
              <div style={{ marginBottom: 2 }}><b>Skupina</b> = typ partie / remeslo (omietkár-sadra, omietkár-vc, maliar, poterár…). Určuje, kde sa parťák zobrazí v Rozpise prác — <b style={{ color: '#b45309' }}>parťák bez Skupiny sa v Rozpise NEZOBRAZÍ.</b></div>
              <div style={{ marginBottom: 2 }}><b>Partia</b> = parťák + jeho ľudia s rovnakou Partiou. Aj 1 zamestnanec môže byť partia. Členovia sú robotníci — <b>NIE majster/office/majiteľ/šofér</b>.</div>
              <div style={{ color: '#64748b', marginTop: 4 }}><b>Novú partiu</b> vytvoríš: zaškrtni PARŤÁK + vyber mu <b>Skupinu</b> a <b>Partiu</b> (alebo „+ Nová partia"). Ostatných členov priradíš k tej istej Partii.</div>
            </div>
            {jeSubdodavka(ed.values) && (
              <div style={{ background: 'rgba(245,158,11,0.08)', border: `1px solid ${COLORS.total}`, borderRadius: RADIUS.md, padding: SPACE.md, fontSize: TYPO.sizes.xs, color: COLORS.text, lineHeight: 1.55 }}>
                <div style={{ fontWeight: TYPO.weights.bold, color: COLORS.total, marginBottom: 4 }}>Subdodávka — firma alebo SZČO, ktorá pre nás robí práce na zákazkách</div>
                <div>{subInyPartak
                  ? <>V partii <b>{subInyPartak.partia}</b> je parťák <b>{subInyPartak.meno}</b> — subdodávka je <b>členom partie</b>, parťák ostáva a mení sa len, <b>kto za partiu fakturuje</b>.</>
                  : <>Je <b>parťák</b> svojej partie (partia nemá iného parťáka) a zobrazí sa v <b>Rozpise prác</b> vo vybranej skupine.</>} Povinné je <b>IČO</b> (Hľadať doplní firmu, sídlo, IČ DPH a DIČ), <b>skupina</b> a <b>rola</b> (ak dostane konto do Matrixu).</div>
                <div>Mzdu nemá — náklad ide cez <b>došlé faktúry</b> na zákazku. Partner v Partneroch sa vytvorí alebo prepojí sám podľa IČO.</div>
              </div>
            )}
            {/* PARŤÁK checkbox — výrazný (ústava sek. 3) */}
            <label style={{ display: 'flex', alignItems: 'center', gap: SPACE.sm,
              padding: SPACE.md, border: `2px solid ${COLORS.total}`,
              borderRadius: RADIUS.md, background: 'rgba(245,158,11,0.08)', cursor: 'pointer' }}>
              <input type="checkbox" checked={!!ed.values.is_partak || subPartakPovinny} disabled={readOnly || subPartakPovinny}
                onChange={e => ed.set('is_partak', e.target.checked)}
                style={{ width: 20, height: 20 }} />
              <div>
                <div style={{ fontWeight: TYPO.weights.bold, color: COLORS.total }}>
                  PARŤÁK — vedúci partie
                </div>
                <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>
                  Zobrazuje sa v Rozpise prác · Píše denník na mobile · NEZÁVISLÉ od remesla (ústava 3)
                </div>
              </div>
            </label>
            {/* ZÁSKOK ZA ŠOFÉRA (Mirko 19. 9. 2026: „Kopaňák robí aj to, čo Tomšu, iba ak Tomšu nestíha") */}
            <label style={{ display: 'flex', alignItems: 'center', gap: SPACE.sm, padding: SPACE.md,
              border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, cursor: 'pointer' }}>
              <input type="checkbox" checked={!!ed.values.sofer_zastup} disabled={readOnly}
                onChange={e => ed.set('sofer_zastup', e.target.checked)}
                style={{ width: 20, height: 20 }} />
              <div>
                <div style={{ fontWeight: TYPO.weights.bold }}>Môže zaskakovať ako šofér</div>
                <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>
                  Matrix ho ponúkne pri zvážaní materiálu a paliet zo stavby, keď hlavný šofér nestíha (ústava 122.4).
                </div>
              </div>
            </label>
            {/* DOCHÁDZKA — prepínač na karte (Mirko 25. 9. 2026: „prepínač pri každom, office si zvolí“; ústava 121.15) */}
            <label style={{ display: 'flex', alignItems: 'center', gap: SPACE.sm, padding: SPACE.md,
              border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, cursor: 'pointer' }}>
              <input type="checkbox" checked={!!ed.values.attendance_required} disabled={readOnly}
                onChange={e => ed.set('attendance_required', e.target.checked)}
                style={{ width: 20, height: 20 }} />
              <div>
                <div style={{ fontWeight: TYPO.weights.bold }}>Dochádzka — príchod a odchod v mobile</div>
                <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>
                  Bez zapnutia človek nevidí Dochádzku v mobile a nie je v prehľade hodín. Platí pre zamestnanca aj subdodávku; typ mzdy o tom nerozhoduje — pri úkole a IČO sú hodiny len kontrola, nie mzda.
                </div>
              </div>
            </label>
            {/* RÉŽIA — povoliť ručné zadanie mzdy (Mirko 2026-06-12) */}
            {!jeSubdodavka(ed.values) && (<label style={{ display: 'flex', alignItems: 'center', gap: SPACE.sm,
              padding: SPACE.md, border: `2px solid ${COLORS.nav}`,
              borderRadius: RADIUS.md, background: 'rgba(59,130,246,0.07)', cursor: 'pointer' }}>
              <input type="checkbox" checked={!!ed.values.manual_payroll} disabled={readOnly}
                onChange={e => ed.set('manual_payroll', e.target.checked)}
                style={{ width: 20, height: 20 }} />
              <div>
                <div style={{ fontWeight: TYPO.weights.bold, color: COLORS.nav }}>
                  Réžia — povoliť ručné zadanie mzdy
                </div>
                <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>
                  Office · šofér · skladník · predajňa · majiteľ. Stavebné práce (partie) majú mzdu LEN cez Podklady (Výmery) — ručne sa nezadáva.
                </div>
              </div>
            </label>)}
            <style>{'.zam-form > * { min-width: 0 } .zam-form input, .zam-form select, .zam-form textarea { max-width: 100%; box-sizing: border-box }'}</style>   {/* ZAMESTNANCI_MOCKUP_V2: Mirko „scroll aby hore dole nie do strán“ */}
            <div className="zam-form" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 300px), 1fr))', gap: SPACE.md }}>
              <Field label={jeSubdodavka(ed.values) ? 'Názov v Rozpise (firma alebo meno) *' : 'Meno *'}>
                <input type="text" value={ed.values.firstName} disabled={readOnly}
                  onChange={e => ed.set('firstName', e.target.value)} style={inputStyle} /></Field>
              <Field label={jeSubdodavka(ed.values) ? 'Priezvisko (nepovinné)' : 'Priezvisko *'}>
                <input type="text" value={ed.values.lastName} disabled={readOnly}
                  onChange={e => ed.set('lastName', e.target.value)} style={inputStyle} /></Field>
              {!jeSubdodavka(ed.values) && <>
              <Field label="Titul (nepovinné)">
                <input type="text" value={ed.values.titul} disabled={readOnly} placeholder="napr. Bc., Ing."
                  onChange={e => ed.set('titul', e.target.value)} style={inputStyle} /></Field>
              <Field label="Funkcia (v podpise e-mailov a dokumentov)">
                <input type="text" value={ed.values.funkcia} disabled={readOnly} placeholder="napr. konateľ, vedúca office, technik"
                  onChange={e => ed.set('funkcia', e.target.value)} style={inputStyle} />
                <div style={{ fontSize: 11, color: COLORS.muted, marginTop: 3 }}>Podpis: <b>{[ed.values.titul, [ed.values.firstName, ed.values.lastName].filter(Boolean).join(' ')].filter(Boolean).join(' ')}{ed.values.funkcia ? ' - ' + ed.values.funkcia : ''}</b></div></Field>
              </>}
              {jeSubdodavka(ed.values) ? (<>
              <Field label="IČ DPH (ak nie je platiteľ DPH, DIČ)">
                <input value={ed.values.ic_dph} disabled={readOnly} placeholder="napr. SK2023089178"
                  title="Doplní sa z registra podľa IČO; uloží sa k partnerovi"
                  onChange={e => ed.set('ic_dph', e.target.value)} style={inputStyle} /></Field>
              <Field label="DIČ">
                <input value={ed.values.dic} disabled={readOnly} placeholder="napr. 2023089178"
                  onChange={e => ed.set('dic', e.target.value)} style={inputStyle} /></Field>
              </>) : (<>
              <Field label="Dátum narodenia">
                <input type="date" value={ed.values.birth_date} disabled={readOnly}
                  onChange={e => ed.set('birth_date', e.target.value)} style={inputStyle} />
                {record?.id && user?.username === 'mirko' ? (
                  <label style={{ display: 'flex', gap: 6, alignItems: 'center', fontSize: 11, color: COLORS.muted, marginTop: 4 }}>
                    <input type="checkbox" checked={nepripom} onChange={async ev => {
                      const v = ev.target.checked
                      const r = await fetchAuth(`${CFG.apiBase}/${record.id}/narodeniny-pripominat`, { method: 'POST', body: JSON.stringify({ nepripominat: v }) })
                      if (r.ok) { setNepripom(v); toastModal.show(v ? 'Pripomínanie narodenín vypnuté' : 'Pripomínanie narodenín zapnuté', 'success') } else toastModal.show('Nepodarilo sa uložiť', 'error')
                    }} /> Nepripomínať narodeniny (vypína len Mirko)
                  </label>
                ) : (nepripom ? <div style={{ fontSize: 11, color: COLORS.muted, marginTop: 4 }}>Pripomínanie narodenín vypol Mirko.</div> : null)}
                <div style={{ fontSize: 11, color: COLORS.muted, marginTop: 3, lineHeight: 1.4 }}>Dátum narodenia, rodné číslo a mzdové údaje mení vedenie, inak so schválením Mirka PIN-om. Vlastné si nemeníš.</div></Field>
              <Field label="Číslo OP / vodičského preukazu">
                <input value={ed.values.doklad_cislo} disabled={readOnly} placeholder="napr. SK123456"
                  title="Potrebné na Potvrdenie o činnostiach vodiča a na Splnomocnenie na vozidlo"
                  onChange={e => ed.set('doklad_cislo', e.target.value)} style={inputStyle} /></Field>
              <Field label="Dátum nástupu do firmy">
                <input type="date" value={ed.values.datum_nastupu} disabled={readOnly}
                  title="Vypĺňa sa do Potvrdenia o činnostiach vodiča (bod 11)"
                  onChange={e => ed.set('datum_nastupu', e.target.value)} style={inputStyle} /></Field>
              </>)}
              {/* ZAMESTNANEC_ADRESA_V1 (Mirko 20. 10. 2026): adresa v bunkách — do dokumentov ide poskladaná · ADRESA_BUNKY_V1 (27. 10. 2026): spoločný blok AdresaBunky (0.J), dve bunky mriežky ako doteraz */}
              <AdresaBunky rozlozenie="bunky" nadpis={jeSubdodavka(ed.values) ? 'Sídlo firmy' : 'Adresa trvalého pobytu'} hodnota={ed.values} zmen={o => ed.setValues(o)} disabled={readOnly}
                labelStyle={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold, color: COLORS.muted, marginBottom: 4, textTransform: 'uppercase', letterSpacing: '0.04em' }}
                inputStyle={inputStyle} tituly={{ adresa_ulica: 'Potrebné na splnomocnenia, zmluvy a plnú moc' }} />
              {ed.values.rodne_cislo !== undefined && !jeSubdodavka(ed.values) && (
                <Field label="Rodné číslo">
                  <input value={ed.values.rodne_cislo} disabled={readOnly} placeholder="napr. 900101/1234"
                    title="Vidí a mení len vedenie, office a účtovníčka. Potrebné na plnú moc a zmluvy."
                    onChange={e => ed.set('rodne_cislo', e.target.value)} style={inputStyle} /></Field>
              )}
              <Field label="Národnosť (určuje jazyk denníka)">
                <SearchableSelect value={ed.values.nationality}
                  onChange={v => ed.set('nationality', v)}
                  options={NATIONALITIES} /></Field>
              <Field label="Typ zamestnania">
                <SearchableSelect value={ed.values.employee_type}
                  onChange={v => { ed.set('employee_type', v); if (v === 'szco') ed.set('uvazok', 'SZČO'); else if (v === 'employee' && /^(SZ[CČ]O|subdod)/i.test(ed.values.uvazok || '')) ed.set('uvazok', 'TPP'); if (v === TYP_SUBDODAVKA) { if (!inyPartakPartie(ed.values, partyList, record?.id)) ed.set('is_partak', true); if (!PLATBY_SUBDODAVKY.includes(ed.values.payType)) ed.set('payType', 'faktúra') } }}
                  options={[
                    { value: 'employee', label: 'Zamestnanec' },
                    { value: 'szco',     label: 'SZČO (živnostník)' },
                    { value: TYP_SUBDODAVKA, label: 'Subdodávka (firma alebo SZČO)' },
                  ]} />
                <div style={{ fontSize: 11, color: COLORS.muted, marginTop: 3, lineHeight: 1.4 }}>Zamestnanec (pracovná zmluva), SZČO (živnostník — fakturuje cez IČO, auto-prepojí partnera) alebo Subdodávka (firma alebo SZČO, ktorá pre nás robí práce na zákazkách — parťák, ak partia nemá parťáka, inak člen partie, náklad cez došlé faktúry).</div></Field>
              <Field label={jeSubdodavka(ed.values) ? 'Skupina *' : 'Skupina'}>
                <SearchableSelect value={ed.values.category}
                  onChange={v => ed.set('category', v)}
                  options={[
                    { value: '', label: '— bez skupiny —' },
                    ...groupList.map(g => ({ value: g.id, label: g.label }))
                  ]}
                  placeholder="Vyber skupinu…" />
                <div style={{ fontSize: 11, color: COLORS.muted, marginTop: 3, lineHeight: 1.4 }}>REMESLO — čo robí rukami (omietkár / maliar / poterár). Určuje sekciu v Rozpise prác. NIE je to to isté ako Rola.</div>
                {ed.values.is_partak && ed.values.category && (() => {
                  const grp = groupList.find(g => g.id === ed.values.category)
                  return grp ? (
                    <div style={{ display: 'flex', alignItems: 'center', gap: SPACE.xs, marginTop: 4, fontSize: TYPO.sizes.xs, color: COLORS.muted }}>
                      <span style={{ width: 14, height: 14, borderRadius: 3, background: grp.color, display: 'inline-block', border: `1px solid ${COLORS.line}` }} />
                      <span>farba parťáka v Rozpise: <code style={{ fontFamily: TYPO.mono }}>{grp.color}</code></span>
                    </div>
                  ) : null
                })()}
              </Field>
              <Field label="Partia (vlákno do Rozpisu prác · 1 zamestnanec = 1 partia OK, ústava 3)">
                <div style={{ display: 'flex', gap: SPACE.xs, alignItems: 'stretch' }}>
                  <div style={{ flex: 1 }}>
                    <SearchableSelect value={ed.values.party}
                      onChange={v => { ed.set('party', v); if (jeSubdodavka(ed.values)) ed.set('is_partak', !inyPartakPartie({ ...ed.values, party: v }, partyList, record?.id)) }}
                      options={[
                        { value: '', label: '— bez partie —' },
                        ...partyList.filter(p => p.active !== 0 && (p.has_partak || p.id === ed.values.party)).map(p => ({ value: p.id, label: p.name + ' (' + p.id + ')' + (p.partak_name ? ' — ' + p.partak_name : '') }))
                      ]}
                      placeholder="Vyber existujúcu partiu…" />
                  </div>
                  <button type="button" onClick={() => setShowNewParty(true)} disabled={readOnly}
                    style={{
                      padding: '0 12px', whiteSpace: 'nowrap',
                      background: COLORS.add, color: '#fff', border: 'none',
                      borderRadius: RADIUS.md, cursor: readOnly ? 'not-allowed' : 'pointer',
                      fontSize: TYPO.sizes.sm, fontWeight: TYPO.weights.semibold, fontFamily: 'inherit',
                    }}>+ Nová partia</button>
                </div>
                {ed.values.party && (() => {
                  const pp = partyList.find(p => p.id === ed.values.party)
                  return pp ? (
                    <div style={{ display: 'flex', alignItems: 'center', gap: SPACE.xs, marginTop: 4, fontSize: TYPO.sizes.xs, color: COLORS.muted }}>
                      <span style={{ width: 14, height: 14, borderRadius: 3, background: pp.color, display: 'inline-block', border: `1px solid ${COLORS.line}` }} />
                      <span>farba partie · ID <code style={{ fontFamily: TYPO.mono }}>{pp.id}</code></span>
                    </div>
                  ) : null
                })()}
              </Field>
              <Field label={jeSubdodavka(ed.values) ? 'Rola * (prístup, ak dostane konto do Matrixu)' : 'Rola'}>
                <SearchableSelect value={ed.values.role}
                  onChange={v => ed.set('role', v)}
                  options={toOpts(opts.roles)}
                  placeholder="Hľadať alebo pridať rolu…"
                  allowCreate />
                <div style={{ fontSize: 11, color: COLORS.muted, marginTop: 3, lineHeight: 1.4 }}>POSTAVENIE + PRÍSTUP do Matrixu — majiteľ / office / zamestnanec / majster / šofér. Nezávislé od remesla (Skupina). Bežný robotník = zamestnanec (bez prístupu).</div></Field>
              {!jeSubdodavka(ed.values) && (
              <Field label="Typ úväzku">
                {ed.values.employee_type === 'szco' ? (
                  <div style={{ ...inputStyle, background: COLORS.bg, color: COLORS.muted }}>SZČO — podľa typu zamestnania</div>
                ) : (
                <SearchableSelect value={ed.values.uvazok}
                  onChange={v => ed.set('uvazok', v)}
                  options={toOpts(opts.uvazky.filter(u => !/^SZ[CČ]O$/i.test(u)))}
                  placeholder="TPP / DPP / DoVP / DoBP / Externe"
                  allowCreate />
                )}</Field>
              )}
              <Field label="Typ platby">
                <SearchableSelect value={ed.values.payType}
                  onChange={v => ed.set('payType', v)}
                  options={toOpts(jeSubdodavka(ed.values) ? PLATBY_SUBDODAVKY : opts.payTypes)}
                  placeholder={jeSubdodavka(ed.values) ? 'faktúra / hotovosť' : 'hodinová / úkolová / mesačná'}
                  allowCreate /></Field>
              {!jeSubdodavka(ed.values) && (<>
              <Field label="Sadzba (€)">
                <input type="number" step="0.01" value={ed.values.rate} disabled={readOnly}
                  onChange={e => ed.set('rate', e.target.value)} style={inputStyle} />
                <div style={{ fontSize: 11, color: COLORS.muted, marginTop: 3, lineHeight: 1.4 }}>€ podľa Typu platby: hodinová = €/hod · mesačná = €/mes · úkolová = €/jednotku.</div></Field>
              <Field label="Míľnik m²/mesiac (bonus)">
                <input type="number" step="1" value={ed.values.milestone_m2} disabled={readOnly}
                  onChange={e => ed.set('milestone_m2', e.target.value)} style={inputStyle} placeholder="0 = bez míľnika" />
                <div style={{ fontSize: 11, color: COLORS.muted, marginTop: 3, lineHeight: 1.4 }}>Ak urobí ≥ toľko m² za KOMPLETNÝ mesiac → bonus. 0 = vypnuté.</div></Field>
              </>)}
              <Field label="Telefón">
                <TelefonInput value={ed.values.phone} disabled={readOnly}
                  onChange={v => ed.set('phone', v)} style={inputStyle} /></Field>
              <Field label="E-mail">
                <input type="email" value={ed.values.email} disabled={readOnly}
                  onChange={e => ed.set('email', e.target.value)} style={inputStyle} placeholder="napr. meno@gmail.com" /></Field>
              <Field label={jeSubdodavka(ed.values) ? 'IČO * — Hľadať v registri' : ed.values.employee_type === 'szco' ? "IČO (SZČO) — Hľadať na ORSR/ZRSR" : "IČO (voliteľne)"}>
                <div style={{ display: 'flex', gap: SPACE.xs }}>
                  <input type="text" value={ed.values.ico} disabled={readOnly}
                    onChange={e => ed.set('ico', e.target.value)}
                    placeholder="napr. 12345678" style={{ ...inputStyle, flex: 1 }} />
                  <button type="button" onClick={() => lookupIcoZam(ed)}
                    disabled={readOnly || lookingUp || !ed.values.ico?.trim()}
                    style={{
                      padding: '0 12px', whiteSpace: 'nowrap',
                      background: COLORS.nav, color: '#fff', border: 'none',
                      borderRadius: RADIUS.md, cursor: 'pointer',
                      fontSize: TYPO.sizes.sm, fontWeight: TYPO.weights.semibold, fontFamily: 'inherit',
                      opacity: (readOnly || lookingUp || !ed.values.ico?.trim()) ? 0.5 : 1,
                    }}>{lookingUp ? '…' : 'Hľadať'}</button>
                </div>
                {jeSubdodavka(ed.values) && (
                  <div style={{ fontSize: 11, color: COLORS.muted, marginTop: 3, lineHeight: 1.4 }}>{ed.values.firma ? <>Firma: <b>{ed.values.firma}</b> — </> : null}v Partneroch sa vytvorí alebo prepojí podľa IČO.</div>
                )}
                {!readOnly && !(ed.values.ico || '').trim() && szcoNavrh.map(n => (
                  <div key={n.partner_id} style={{ marginTop: 6, padding: '6px 8px', border: `1px solid ${COLORS.nav}`, borderRadius: RADIUS.md, background: 'rgba(29,78,216,0.06)', fontSize: 12, display: 'flex', gap: 8, alignItems: 'center' }}>
                    <span style={{ flex: 1 }}>V Partneroch je SZČO <b>{n.nazov}</b> · IČO {n.ico}{n.dosle_fa ? ` · ${n.dosle_fa} došlých FA` : ''}. Je to táto osoba?</span>
                    <button type="button" onClick={() => prepojSzco(n)} style={{ padding: '3px 10px', background: COLORS.nav, color: '#fff', border: 'none', borderRadius: RADIUS.md, cursor: 'pointer', fontSize: 12, fontWeight: 600, fontFamily: 'inherit' }}>Prepojiť</button>
                  </div>
                ))}
              </Field>
            </div>
            {!jeSubdodavka(ed.values) && (
            <RatesEditor
              value={ed.values.rates}
              onChange={v => ed.set('rates', v)}
              readOnly={readOnly} />
            )}
            <Field label="Poznámka">
              <textarea value={ed.values.notes} disabled={readOnly}
                onChange={e => ed.set('notes', e.target.value)} rows={3}
                style={{ ...inputStyle, resize: 'vertical' }} /></Field>
          </div>
        ) : (
          // ── CONFIRM fáza — DIFF prehľad (ústava 53.8) ───────────────
          <div>
            {isNew ? (
              <p style={{ fontSize: TYPO.sizes.base, color: COLORS.text }}>
                {jeSubdodavka(ed.values) ? 'Vytvorí sa nová subdodávka' : 'Vytvorí sa nový zamestnanec'} <strong>{ed.values.firstName} {ed.values.lastName}</strong>.
              </p>
            ) : ed.diff.length === 0 ? (
              <p style={{ color: COLORS.muted }}>Žiadne zmeny.</p>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: TYPO.sizes.sm }}>
                <thead>
                  <tr style={{ background: TINT.nav }}>
                    <th style={thStyle}>Pole</th>
                    <th style={thStyle}>Pôvodné</th>
                    <th style={thStyle}>Nové</th>
                  </tr>
                </thead>
                <tbody>
                  {ed.diff.map(d => (
                    <tr key={d.name}>
                      <td style={tdStyle}>{d.label}</td>
                      <td style={{ ...tdStyle, color: COLORS.muted, textDecoration: 'line-through' }}>
                        {d.from}
                      </td>
                      <td style={{ ...tdStyle, color: COLORS.add, fontWeight: TYPO.weights.semibold }}>
                        {d.to}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}
      </Modal>

      {showNewParty && (
        <PartyCreateMini
          zamestnanec={ed.values}
          onClose={() => setShowNewParty(false)}
          onCreated={(newParty) => {
            loadParties()
            ed.set('party', newParty.id)
            if (!ed.values.is_partak) ed.set('is_partak', 1)   // p36: kto zakladá partiu z karty, je jej parťák (ústava 3)
            setShowNewParty(false)
          }}
        />
      )}

      {/* DIRTY dialóg — Uložiť / Pokračovať / Zahodiť (ústava 53.1) */}
      <Modal.DirtyConfirm {...ed.dirtyProps} />
    </>
  )
}

function Field({ label, children }) {
  return (
    <label style={{ display: 'block' }}>
      <div style={{
        fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold,
        color: COLORS.muted, marginBottom: 4, textTransform: 'uppercase',
        letterSpacing: '0.04em',
      }}>{label}</div>
      {children}
    </label>
  )
}

const inputStyle = {
  width: '100%',
  padding: '6px 10px',
  fontSize: TYPO.sizes.base,
  fontFamily: 'inherit',
  border: `1px solid ${COLORS.line}`,
  borderRadius: RADIUS.md,
  outline: 'none',
  boxSizing: 'border-box',
}
const thStyle = {
  textAlign: 'left', padding: '6px 10px',
  fontSize: TYPO.sizes.xs, color: COLORS.nav,
  textTransform: 'uppercase', letterSpacing: '0.04em',
  borderBottom: `1px solid ${COLORS.line}`,
}
const tdStyle = {
  padding: '6px 10px',
  borderBottom: `1px solid ${COLORS.lineSoft}`,
}

// ╔══════════════════════════════════════════════════════════════════╗
// ║  DoD CHECKLIST — skopíruj do HANDOFF, odškrtni pred dokončením    ║
// ║  (ústava 9.D.1 bod 3). Modul NIE JE hotový kým nie sú všetky ✅.  ║
// ╠══════════════════════════════════════════════════════════════════╣
// ║  [ ] CFG vyplnené (resource, apiBase, labels)                    ║
// ║  [ ] EDIT_FIELDS = všetky editovateľné polia (kvôli DIFF)        ║
// ║  [ ] LOCK funguje — test 2 okná naraz (53.7)                     ║
// ║  [ ] DIRTY dialóg pri zatvorení s neuloženými zmenami (53.1)     ║
// ║  [ ] Form → Confirm + DIFF pred uložením (12.0/3, 53.8)         ║
// ║  [ ] HistoryPanel ukazuje audit záznamu (12.0/1)                 ║
// ║  [ ] hľadanie v zozname funguje (56)                             ║
// ║  [ ] žiadny plain <select> — len SearchableSelect (56.11)        ║
// ║  [ ] žiadne inline farby pozadia — len TINT/tint() (21.15)       ║
// ║  [ ] dedup — backend vracia 409 pri duplicite (13)               ║
// ║  [ ] mod+N a / skratky + cheatsheet (54)                         ║
// ║  [ ] starý modul porovnaný — všetky polia/funkcie prenesené      ║
// ║  [ ] ÚSTAVA-REVIEW — druhý prechod kódu bod po bode (9.D.3)      ║
// ╚══════════════════════════════════════════════════════════════════╝

// SMS história s daným číslom (Mirko 22.7.: „celá komunikácia nech je vidieť aj u každého používateľa")
function SmsHistoria({ phone }) {
  const [msgs, setMsgs] = React.useState(null)
  const [open, setOpen] = React.useState(false)
  React.useEffect(() => {
    if (!open) return
    fetchAuth('/api/sms/vlakno?phone=' + encodeURIComponent(phone)).then(r => r.json()).then(setMsgs).catch(() => setMsgs([]))
  }, [open, phone])
  const cas = (t) => { try { const d = new Date(String(t).replace(' ', 'T') + 'Z'); return isNaN(d) ? '' : d.toLocaleString('sk-SK', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) } catch (_) { return '' } }
  return (
    <div style={{ margin: '6px 0 2px' }}>
      <span onClick={() => setOpen(v => !v)} style={{ fontSize: 12, fontWeight: 700, color: '#0369a1', cursor: 'pointer' }}>
        {open ? 'Skryť SMS históriu' : 'Zobraziť SMS históriu s týmto číslom'}
      </span>
      {open && (
        msgs === null ? <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 4 }}>Načítavam…</div> :
        !msgs.length ? <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 4 }}>Žiadne SMS s týmto číslom.</div> :
        <div style={{ maxHeight: 220, overflowY: 'auto', marginTop: 6, paddingRight: 4 }}>
          {msgs.map(m => (
            <div key={m.id} style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 6 }}>
              <div style={{ maxWidth: '85%' }}>
                <div style={{ background: m.status === 'sent' ? '#2fb457' : '#dc2626', color: '#fff', borderRadius: '12px 12px 3px 12px', padding: '6px 10px', fontSize: 12.5, whiteSpace: 'pre-wrap' }}>{m.text}</div>
                <div style={{ textAlign: 'right', fontSize: 10, color: '#94a3b8', marginTop: 1 }}>{m.kto ? m.kto + ' · ' : ''}{cas(m.created_at)}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
